/*!
 * Hattibotti – Hattulan Puun asiakaschat
 * Ladataan snippets/hattibotti.liquid -tiedostosta. Ei riippuvuuksia; PDF-tiedostojen
 * lukemiseen ladataan pdf.js (cdnjs) vasta kun asiakas liittää PDF:n.
 * Asetukset script-tagin data-attribuuteista:
 *   data-endpoint       Supabase-funktion osoite (pakollinen)
 *   data-privacy-url    tietosuojasivu (oletus /pages/evasteet)
 *   data-offset-bottom  painikkeen etäisyys alareunasta pikseleinä (oletus 20)
 */
(function () {
  "use strict";
  if (window.__hattibotti) return;
  window.__hattibotti = true;

  var script = document.currentScript;
  var cfg = Object.assign({}, window.HATTIBOTTI_CONFIG || {}, script ? script.dataset : {});
  var ENDPOINT = cfg.endpoint;
  if (!ENDPOINT) {
    console.warn("Hattibotti: data-endpoint puuttuu");
    return;
  }
  var PRIVACY_URL = cfg.privacyUrl || "https://hattulanpuu.fi/pages/evasteet";
  var OFFSET = parseInt(cfg.offsetBottom || "20", 10) || 20;
  var STORE_KEY = "hattibotti:v1";
  var MAX_IMAGE_SIDE = 1568;
  var SHOP_HOST = location.hostname;
  var PRKL_PATH = cfg.prklPath || "/pages/prkl";
  var LEVY_PATH = cfg.levyPath || "/pages/levysahaus";
  var INTENT_KEY = "hattibotti:intent";
  // PDF: sivut muutetaan kuviksi asiakkaan selaimessa
  var PDFJS_BASE = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/";
  var PDF_MAX_BYTES = 20 * 1024 * 1024; // luettavan tiedoston enimmäiskoko
  var PDF_SEND_MAX_BYTES = 5 * 1024 * 1024; // alkuperäinen PDF myyjälle, jos enintään tämän kokoinen
  var PDF_MAX_PAGES = 4; // kuviksi muutettavat sivut
  var PDF_TEXT_PAGES = 12; // sivut, joilta poimitaan teksti
  var PDF_TEXT_MAX = 15000;
  var PDF_SIDE = 1568; // sivukuvan pidempi sivu pikseleinä (Claude käyttää enintään tämän kokoisia)
  var PDF_TILE = 1560; // suurennosruudun enimmäiskoko pikseleinä
  var PDF_TILE_PX_PER_PT = 1.8; // suurennosten tarkkuus: 2,5 mm teksti ≈ 12 px
  var PDF_MAX_TILES = 6; // suurennoksia enintään (A1 = 3 × 2)
  // Liitteet: enintään 3 kuvaa tai PDF:ää viestissä. Useampi PDF jakaa kuvabudjetin ja
  // alkuperäisten tiedostojen kokorajan (sama raja palvelimella: LIMITS.attachments ja pdfImagesTotal)
  var MAX_ATTACHMENTS = 3;
  var PDF_IMAGES_TOTAL = 16;
  var PDF_IMAGES_PER_FILE = 10;

  // ------------------------------------------------------------------
  // Tila
  // ------------------------------------------------------------------
  var state = {
    id: null,
    token: null,
    status: "bot",
    lastId: 0,
    open: false,
    busy: false,
    restored: false,
    unread: 0,
    atts: [], // liitteet, joita ei ole vielä lähetetty: { kind: "image" | "pdf", ready, preview, … }
    slowUntil: 0, // viestitahti hidastettu: seuraava viesti aikaisintaan (ms)
    preparing: false, // jokin liite on vielä käsittelyssä
    seen: new Set(),
    hello: null,
  };

  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(STORE_KEY) || "null");
      if (s && s.id && s.token) {
        state.id = s.id;
        state.token = s.token;
        state.status = s.status || "bot";
      }
    } catch (e) {}
  }
  function save() {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify({ id: state.id, token: state.token, status: state.status }));
    } catch (e) {}
  }
  // Selaimen pysyvä tunniste rajoja varten (liitteet / vrk ja viestitahti). Säilyy keskustelun tyhjennyksen yli.
  var CID_KEY = "hattibotti:cid";
  var SLOW_KEY = "hattibotti:slow";
  var memCid = null;
  function clientId() {
    var v = null;
    try {
      v = localStorage.getItem(CID_KEY);
    } catch (e) {}
    if (!v || !/^[a-z0-9]{16,64}$/.test(v)) {
      v = memCid;
      if (!v) {
        var a = new Uint8Array(12);
        if (window.crypto && crypto.getRandomValues) crypto.getRandomValues(a);
        else for (var i = 0; i < a.length; i++) a[i] = (Math.random() * 256) | 0;
        v = Array.prototype.map
          .call(a, function (b) {
            return ("0" + b.toString(16)).slice(-2);
          })
          .join("");
      }
      try {
        localStorage.setItem(CID_KEY, v);
      } catch (e) {}
    }
    memCid = v;
    return v;
  }

  function forget() {
    state.id = null;
    state.token = null;
    state.status = "bot";
    state.lastId = 0;
    state.seen = new Set();
    try {
      localStorage.removeItem(STORE_KEY);
    } catch (e) {}
  }

  // ------------------------------------------------------------------
  // Ulkoasu
  // ------------------------------------------------------------------
  var CSS = [
    ":host{all:initial}",
    "*,*::before,*::after{box-sizing:border-box}",
    ".hb{--g:#234232;--g2:#2f5a43;--leaf:#a9dd9a;--ink:#1d2420;--mute:#66706a;--line:#e1e6dd;--bg:#f5f7f3;--pine:#8a5a1f;--pinebg:#fcf2e2;--pineline:#efd8b0;",
    "font-family:var(--hb-font,system-ui,-apple-system,'Segoe UI',Roboto,sans-serif);font-size:15px;line-height:1.45;color:var(--ink);-webkit-font-smoothing:antialiased}",
    "button{font:inherit;color:inherit;cursor:pointer}",
    ":focus-visible{outline:2px solid var(--leaf);outline-offset:2px}",

    /* Painike: Hattibotti-aave */
    ".launch{position:fixed;right:18px;bottom:calc(var(--off) + env(safe-area-inset-bottom,0px));width:44px;height:57px;padding:0;border:0;background:transparent;display:block;z-index:2147483000;filter:drop-shadow(0 5px 9px rgba(20,45,30,.35));transition:transform .18s ease;-webkit-tap-highlight-color:transparent}",
    ".launch:hover{transform:translateY(-3px)}",
    ".launch svg.ghost{display:block;width:41px;height:57px;margin:0 auto;animation:hb-float 3.6s ease-in-out infinite}",
    "@keyframes hb-float{0%,100%{transform:none}50%{transform:translateY(-3px)}}",
    ".launch .eyes,.launch .pupils{transform-box:view-box;transform-origin:50px 46px;animation:hb-blink 6s infinite}",
    ".launch .pu{animation:hb-look 9s ease-in-out infinite}",
    "@keyframes hb-blink{0%,92%,100%{transform:none}94.5%{transform:scaleY(.1)}}",
    "@keyframes hb-look{0%,40%,100%{transform:none}48%,62%{transform:translateX(-3px)}70%,82%{transform:translateX(3px)}}",
    ".launch .x{display:none;width:40px;height:40px;margin:17px 0 0 2px;border-radius:50%;background:var(--g);place-items:center}",
    ".launch .x svg{width:17px;height:17px;display:block}",
    ".launch[aria-expanded=true] svg.ghost{display:none}",
    ".launch[aria-expanded=true] .x{display:grid}",
    ".badge{position:absolute;top:-5px;left:-7px;min-width:18px;height:18px;padding:0 5px;border-radius:9px;background:var(--leaf);color:var(--g);font-size:11px;font-weight:700;line-height:18px;text-align:center;border:2px solid #fff}",
    ".badge[hidden]{display:none}",
    ".teaser{position:fixed;right:70px;bottom:calc(var(--off) + 17px + env(safe-area-inset-bottom,0px));background:#fff;color:var(--g);border:1px solid var(--line);border-radius:14px 14px 4px 14px;padding:8px 12px;font-size:14px;font-weight:600;box-shadow:0 6px 18px rgba(20,45,30,.16);z-index:2147483000;cursor:pointer;white-space:nowrap}",
    ".teaser[hidden]{display:none}",

    /* Paneeli */
    ".panel{position:fixed;right:20px;bottom:calc(var(--off) + 68px + env(safe-area-inset-bottom,0px));width:min(400px,calc(100vw - 40px));height:min(640px,calc(100vh - var(--off) - 86px));background:#fff;border-radius:18px;box-shadow:0 20px 60px rgba(18,40,28,.30),0 0 0 1px rgba(18,40,28,.06);display:flex;flex-direction:column;overflow:hidden;z-index:2147483001;transform-origin:bottom right;animation:hb-in .18s ease-out}",
    ".panel[hidden]{display:none}",
    "@keyframes hb-in{from{opacity:0;transform:translateY(8px) scale(.98)}to{opacity:1;transform:none}}",
    "header{display:flex;align-items:center;gap:10px;padding:12px 8px 12px 14px;background:var(--g);color:#fff}",
    ".home{flex:none;width:46px;height:46px;border-radius:12px;background:var(--leaf);display:grid;place-items:center;text-decoration:none}",
    ".home:hover{background:#b8e5ab}",
    ".home svg{width:33px;height:40px;display:block;overflow:visible}",
    ".hog .hp-d{fill:#2b3827}.hog .hp-l{fill:#a9dd9a}.hog .hp-s{fill:none;stroke:#2b3827}.hog .hp-puff{fill:#f4fbf1}",
    ".iq{display:inline-block;margin-left:8px;vertical-align:2px;padding:1px 7px;border-radius:999px;border:1px solid rgba(169,221,154,.55);color:var(--leaf);font-size:11.5px;font-weight:700;letter-spacing:.02em}",
    ".note{font-size:11.5px;color:#b9d4b0;font-style:italic;line-height:1.3;margin-top:1px}",
    ".ttl{flex:1;min-width:0}",
    ".name{font-size:17px;font-weight:700;letter-spacing:.01em;line-height:1.2}",
    ".sub{font-size:12.5px;line-height:1.3;color:#cfe3c8;display:flex;align-items:flex-start;gap:6px;margin-top:2px;min-width:0}",
    ".sub .dot{margin-top:5px}",
    ".dot{width:8px;height:8px;border-radius:50%;background:#8a958d;flex:none}",
    ".dot.on{background:var(--leaf);box-shadow:0 0 0 3px rgba(169,221,154,.25)}",
    ".close{width:34px;height:34px;flex:none;border:0;border-radius:10px;background:transparent;color:#fff;display:grid;place-items:center}",
    ".close:hover{background:rgba(255,255,255,.12)}",
    ".close:disabled{opacity:.4;cursor:default;background:transparent}",
    ".close svg{width:20px;height:20px}",
    ".confirm{display:flex;align-items:center;gap:8px;flex-wrap:wrap;padding:10px 14px;background:#fbeae5;color:#7a2a17;font-size:13.5px;border-bottom:1px solid #f1cfc4}",
    ".confirm[hidden]{display:none}",
    ".confirm span{flex:1;min-width:160px}",
    ".cbtn{border:1px solid #e3b6a8;border-radius:8px;padding:6px 11px;font-size:13px;background:#fff;color:#7a2a17}",
    ".cbtn.danger{background:#a33a20;border-color:#a33a20;color:#fff}",
    /* Yhteystiedot */
    ".contacts{display:none;flex:1;overflow-y:auto;background:var(--bg);padding:12px 14px 16px;overscroll-behavior:contain}",
    ".panel.cv .contacts{display:block}",
    ".panel.cv .msgs,.panel.cv footer,.panel.cv .notice,.panel.cv .confirm{display:none}",
    ".back{display:inline-flex;align-items:center;gap:4px;border:0;background:none;color:var(--g);font-size:14px;font-weight:600;padding:4px 2px;margin-bottom:8px}",
    ".back svg{width:18px;height:18px}",
    ".ct{font-size:13px;color:var(--mute);margin:2px 2px 10px}",
    ".pc{display:grid;grid-template-columns:52px 1fr;gap:4px 12px;align-items:center;background:#fff;border:1px solid var(--line);border-radius:14px;padding:10px 12px;margin-bottom:8px;text-decoration:none;color:inherit}",
    ".pc:hover{border-color:#9fc293}",
    ".pc img,.pc .pi{width:52px;height:52px;border-radius:50%;object-fit:cover;background:#e7ece4;grid-row:span 2;display:grid;place-items:center;color:var(--g)}",
    ".pc .pi svg{width:24px;height:24px}",
    ".pc b{font-size:14.5px;line-height:1.25}",
    ".pc small{display:block;font-size:12.5px;color:var(--mute);line-height:1.3}",
    ".num{justify-self:start;display:inline-flex;align-items:center;gap:6px;margin-top:4px;background:#eaf4e5;color:var(--g);border-radius:999px;padding:4px 10px;font-size:13.5px;font-weight:700;white-space:nowrap}",
    ".num svg{width:14px;height:14px}",
    ".mail{font-size:13px;color:var(--mute);margin:10px 2px 0}",
    ".mail a{color:var(--g)}",
    ".notice{padding:9px 16px;background:#eaf4e5;color:var(--g);font-size:13px;border-bottom:1px solid #d6e8cf}",
    ".notice[hidden]{display:none}",
    ".notice.human{background:var(--pinebg);color:var(--pine);border-color:var(--pineline)}",

    /* Viestit */
    ".msgs{flex:1;overflow-y:auto;padding:16px 14px;background:var(--bg);display:flex;flex-direction:column;gap:10px;overscroll-behavior:contain}",
    ".m{max-width:86%;padding:10px 13px;border-radius:16px;word-wrap:break-word;overflow-wrap:anywhere}",
    ".m p{margin:0 0 6px}.m p:last-child{margin:0}",
    ".m ul{margin:4px 0 6px;padding-left:20px}.m li{margin:2px 0}",
    ".m a{color:inherit;text-decoration:underline;text-underline-offset:2px}",
    ".m.bot{align-self:flex-start;background:#fff;border:1px solid var(--line);border-top-left-radius:4px}",
    ".m.user{align-self:flex-end;background:var(--g);color:#fff;border-top-right-radius:4px}",
    ".m.staff{align-self:flex-start;background:var(--pinebg);border:1px solid var(--pineline);border-top-left-radius:4px}",
    ".who{display:block;font-size:12px;font-weight:700;color:var(--pine);margin-bottom:3px}",
    ".m img.photo{display:block;max-width:100%;max-height:240px;border-radius:10px;margin:0 0 6px}",
    ".m.user img.photo:last-child{margin:0}",
    ".m.failed{opacity:.55}",
    ".meta{align-self:flex-end;font-size:12px;color:var(--mute);margin-top:-4px}",
    ".err{align-self:center;font-size:13px;color:#8c2f1c;background:#fbeae5;border-radius:10px;padding:8px 12px;max-width:92%;text-align:center}",
    ".chips{display:flex;flex-wrap:wrap;gap:6px;align-self:flex-start;max-width:100%}",
    ".chip{border:1px solid #bcd6b2;background:#fff;color:var(--g);border-radius:999px;padding:7px 12px;font-size:13.5px;line-height:1.2}",
    ".chip:hover{background:#eef6ea;border-color:var(--g2)}",
    "a.chip{display:inline-flex;align-items:center;text-decoration:none}",
    ".cards{display:flex;flex-direction:column;gap:8px;align-self:stretch}",
    ".card{display:grid;grid-template-columns:64px 1fr;gap:12px;align-items:center;background:#fff;border:1px solid var(--line);border-radius:14px;padding:8px 12px 8px 8px;text-decoration:none;color:inherit;transition:border-color .15s}",
    ".card:hover{border-color:#9fc293}",
    ".card img,.card .ph{width:64px;height:64px;border-radius:10px;object-fit:cover;background:#eceee8;display:block}",
    ".card .t{font-size:14px;font-weight:700;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}",
    ".card .p{font-size:13px;color:var(--g2);margin-top:3px}",
    ".card .na{font-size:12px;color:#9a4b2a;margin-top:2px}",
    ".card .go{font-size:12.5px;color:var(--mute);margin-top:3px;text-decoration:underline;text-underline-offset:2px}",
    ".typing{align-self:flex-start;background:#fff;border:1px solid var(--line);border-radius:4px 16px 16px 16px;padding:12px 14px;display:flex;gap:4px}",
    ".typing i{width:7px;height:7px;border-radius:50%;background:#9aa69e;display:block;animation:hb-b 1.2s infinite ease-in-out}",
    ".typing i:nth-child(2){animation-delay:.15s}.typing i:nth-child(3){animation-delay:.3s}",
    "@keyframes hb-b{0%,80%,100%{opacity:.35;transform:none}40%{opacity:1;transform:translateY(-3px)}}",

    /* Kirjoituskenttä */
    "footer{border-top:1px solid var(--line);padding:10px 10px 8px;background:#fff}",
    ".pv{display:flex;align-items:center;flex-wrap:wrap;gap:10px;margin:4px 0 8px 4px}",
    ".pv[hidden]{display:none}",
    ".pv .ai{position:relative;width:52px;height:52px;flex:none;border-radius:8px;border:1px solid var(--line);background:#f6f8f4;display:grid;place-items:center}",
    ".pv .ai img{width:100%;height:100%;object-fit:cover;object-position:top;border-radius:8px;border:0;display:block}",
    ".pv .ai .dic{color:var(--g);display:grid;place-items:center}.pv .ai .dic svg{width:22px;height:22px}",
    ".pv .ai .tag{position:absolute;left:3px;bottom:3px;font-size:9.5px;font-weight:800;letter-spacing:.02em;background:var(--g);color:#fff;border-radius:4px;padding:1px 4px;line-height:1.25}",
    ".pv .ai .rx{position:absolute;top:-7px;right:-7px;width:22px;height:22px;border-radius:50%;border:2px solid #fff;background:#3d4a39;color:#fff;padding:0;display:grid;place-items:center;cursor:pointer}",
    ".pv .ai .rx:hover{background:#a3311b}",
    ".pv .ai .rx svg{width:12px;height:12px}",
    ".pv .pvt{font-size:13px;color:var(--mute);flex:1;min-width:110px;line-height:1.35}",
    ".m .photos{display:grid;gap:4px;width:240px;max-width:100%;margin:0 0 6px}",
    ".m .photos.n2{grid-template-columns:1fr 1fr}.m .photos.n3{grid-template-columns:1fr 1fr 1fr}",
    ".m .photos img{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:8px;display:block;background:#fff}",
    ".m .photos:last-child{margin:0}",
    ".m .gone{font-size:12.5px;font-style:italic;opacity:.8;margin:0 0 6px}.m .gone:last-child{margin:0}",
    ".ib:disabled{opacity:.4;cursor:default;background:transparent}",
    ".panel.dz .msgs{outline:3px dashed var(--g2);outline-offset:-10px;background:#eef6ea}",
    ".tools{display:flex;gap:6px;flex-wrap:wrap;margin:0 0 8px}",
    ".tool{display:inline-flex;align-items:center;gap:6px;border:1px solid #cfdcc9;background:#f3f7f1;color:var(--g);border-radius:999px;padding:6px 12px 6px 10px;font-size:13px;line-height:1.2}",
    ".tool:hover{background:#e6f0e2;border-color:var(--g2)}",
    ".tool:disabled{opacity:.55;cursor:default;background:#f3f7f1;border-color:#cfdcc9}",
    ".tool svg{width:16px;height:16px;flex:none}",
    ".pv .spin{width:18px;height:18px;border-radius:50%;border:2.5px solid #cfdcc9;border-top-color:var(--g2);animation:hb-spin .8s linear infinite;flex:none}",
    ".pv .spin[hidden]{display:none}",
    "@keyframes hb-spin{to{transform:rotate(360deg)}}",
    ".m .doc{display:flex;align-items:center;gap:9px;margin:0 0 6px}",
    ".m .doc img{width:54px;height:70px;object-fit:cover;object-position:top;border-radius:6px;background:#fff;flex:none}",
    ".m .doc .dic{width:42px;height:52px;border-radius:6px;background:rgba(255,255,255,.18);display:grid;place-items:center;flex:none}",
    ".m .doc .dic svg{width:22px;height:22px}",
    ".m .doc span{font-size:13px;font-weight:600;line-height:1.3;overflow-wrap:anywhere}",
    ".m .doc:last-child{margin:0}",
    ".plan{align-self:stretch;background:#fff;border:1px solid #bcd6b2;border-radius:14px;padding:12px 14px;display:flex;flex-direction:column;gap:8px}",
    ".plan .pt{display:flex;align-items:center;gap:9px;font-weight:700;color:var(--g);font-size:14.5px;line-height:1.3}",
    ".plan .pt svg{width:24px;height:24px;flex:none}",
    ".plan .ps{font-size:13px;color:var(--mute);line-height:1.4}",
    ".plan .pbtn{display:block;text-align:center;background:var(--g);color:#fff;border-radius:10px;padding:10px 12px;font-size:14px;font-weight:700;text-decoration:none}",
    ".plan .pbtn:hover{background:var(--g2)}",
    ".plan .pn{font-size:12px;color:var(--pine);line-height:1.35}",
    /* Rahti: hintakortti ja lomake */
    ".frt{align-self:stretch;background:#fff;border:1px solid #bcd6b2;border-radius:14px;padding:12px 14px;display:flex;flex-direction:column;gap:6px}",
    ".frt .ft{display:flex;align-items:center;gap:9px;font-weight:700;color:var(--g);font-size:14.5px;line-height:1.3}",
    ".frt .ft svg{width:24px;height:24px;flex:none}",
    ".frt .fp{font-size:26px;font-weight:800;color:var(--g);line-height:1.15}",
    ".frt .fp small{font-size:13px;font-weight:600;color:var(--mute);margin-left:6px}",
    ".frt dl{display:grid;grid-template-columns:auto 1fr;gap:3px 12px;margin:2px 0 0;font-size:13.5px;line-height:1.35}",
    ".frt dt{color:var(--mute)}.frt dd{margin:0;font-weight:600}",
    ".frt .fn{font-size:12px;color:var(--mute);line-height:1.35}",
    ".ff{align-self:stretch;background:#fff;border:1px solid #bcd6b2;border-radius:14px;padding:12px 14px;display:grid;grid-template-columns:1fr 1fr;gap:10px}",
    ".ff label{display:flex;flex-direction:column;justify-content:space-between;gap:4px;font-size:12.5px;font-weight:600;color:var(--g);min-width:0}",
    ".ff label.w{grid-column:1/-1}",
    ".ff .lt i{font-style:normal;font-weight:400;color:var(--mute)}",
    ".ff input[type=text],.ff input[type=tel],.ff input[type=date],.ff input[type=time]{font:inherit;font-size:16px;border:1px solid #d3dacf;border-radius:10px;padding:8px 10px;color:var(--ink);background:#fff;min-width:0;width:100%;min-height:40px;box-sizing:border-box}",
    ".ff input[type=text]:focus,.ff input[type=tel]:focus,.ff input[type=date]:focus,.ff input[type=time]:focus{outline:none;border-color:var(--g2);box-shadow:0 0 0 3px rgba(169,221,154,.35)}",
    ".ff label.chk{grid-column:1/-1;flex-direction:row;justify-content:flex-start;align-items:center;gap:8px;font-weight:500;color:var(--ink);font-size:13.5px}",
    ".ff .fb{grid-column:1/-1;border:0;border-radius:10px;padding:10px 12px;background:var(--g);color:#fff;font-weight:700;font-size:14px}",
    ".ff .fb:hover{background:var(--g2)}",
    ".ff .fe{grid-column:1/-1;font-size:12.5px;color:#a3311b}",
    ".ff .fe:empty{display:none}",
    ".ff small{grid-column:1/-1;font-size:12px;color:var(--mute);line-height:1.35}",
    ".ff small[hidden]{display:none}",
    ".ff label.chk input:disabled+*,.ff label.chk:has(input:disabled){color:var(--mute)}",
    ".ff.done{opacity:.55;pointer-events:none}",
    ".meta.left{align-self:flex-start;margin-top:-2px}",
    ".row{display:flex;align-items:flex-end;gap:6px}",
    ".ib{flex:none;width:42px;height:42px;border:0;border-radius:12px;display:grid;place-items:center;background:transparent;color:var(--g)}",
    ".ib:hover{background:#eef3ec}",
    ".ib svg{width:22px;height:22px}",
    ".send{background:var(--g);color:#fff}",
    ".send:hover{background:var(--g2)}",
    ".send:disabled{opacity:.35;cursor:default;background:var(--g)}",
    "textarea{flex:1;min-width:0;resize:none;border:1px solid #d3dacf;border-radius:12px;padding:10px 12px;font:inherit;font-size:15px;line-height:1.4;color:var(--ink);background:#fff;max-height:130px;min-height:42px;outline:none}",
    "textarea:focus{border-color:var(--g2);box-shadow:0 0 0 3px rgba(169,221,154,.35)}",
    ".fine{font-size:11.5px;color:var(--mute);margin:7px 4px 0;line-height:1.35}",
    ".fine a{color:inherit}",
    ".sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}",

    "@media (max-width:640px){",
    ".panel{inset:0;width:100%;height:100%;border-radius:0;animation:none}",
    "header{padding-top:calc(14px + env(safe-area-inset-top,0px))}",
    "footer{padding-bottom:calc(8px + env(safe-area-inset-bottom,0px))}",
    "textarea{font-size:16px}",
    ".launch[aria-expanded=true]{display:none}",
    ".teaser{display:none}",
    /* Puhelimella painikkeen voi raahata toiseen kohtaan */
    ".launch{touch-action:none}",
    ".launch.drag{transform:scale(1.12);filter:drop-shadow(0 10px 16px rgba(20,45,30,.45))}",
    ".launch.drag svg.ghost{animation:none}",
    ".launch.snap{transition:left .22s ease,bottom .22s ease,transform .18s ease}",
    "}",
    "@media (prefers-reduced-motion:reduce){.panel,.typing i,.launch,.launch svg.ghost,.launch .eyes,.launch .pupils,.launch .pu{animation:none;transition:none}}",
  ].join("\n");

  // Siili Hattulan Puun logosta (sama kuin sivuston kotinappi)
  var HOG_SVG =
    '<svg class="hog" viewBox="-3 -7 110 133" aria-hidden="true" focusable="false">' + '<g class="hp-hog"><g class="hp-smoke"><circle class="hp-puff" cx="23.86" cy="-0.43" r="4.88" opacity="1"></circle><circle class="hp-puff" cx="23.2" cy="1.69" r="4.49" opacity="1"></circle><circle class="hp-puff" cx="22.28" cy="4.61" r="3.46" opacity="1"></circle><circle class="hp-puff" cx="21.52" cy="7.94" r="2.46" opacity="0.62"></circle><circle class="hp-puff" cx="21.4" cy="9.5" r="1" opacity="0"></circle><circle class="hp-puff" cx="21.4" cy="9.5" r="1" opacity="0"></circle></g><path class="hp-l" fill-rule="evenodd" d="M81.69 99.7C81.55 99.53 81.47 99.36 81.24 99.29C80.41 99.02 74.8 99.25 73.49 99.25C72.81 99.25 70.96 99.6 70.77 98.67C70.69 98.3 70.65 97.53 70.82 97.18C71.07 96.66 72.95 95.11 73.47 94.57C73.89 94.14 73.61 93.52 73.93 93.05C74.41 92.34 75.83 91.2 76.51 90.55C76.84 90.22 77.49 89.68 77.67 89.26C77.85 88.82 77.65 88.35 78 87.96C78.94 86.9 80.77 85.54 81.54 84.48C81.89 84.02 81.61 83.41 82 82.96C82.97 81.86 84.71 80.6 85.54 79.49C85.86 79.06 85.63 78.51 85.92 78.07L86.57 77.49L88.97 74.98C89.46 74.48 90.2 74.02 90.58 73.43C90.97 72.84 90.75 70.86 90.75 70.09C90.75 69.42 90.95 68.35 90.7 67.72C90.52 67.28 89.93 67.19 89.79 66.73C89.6 66.1 89.93 65.35 89.7 64.73C89.53 64.29 88.94 64.2 88.79 63.74C88.59 63.12 88.92 62.37 88.71 61.75C88.56 61.33 88.06 61.23 87.85 60.87C87.64 60.51 87.65 57.7 87.79 57.26C88.14 56.17 90.01 57.31 90.71 56.23C90.76 55.35 89.88 55.37 89.76 54.62C89.67 54.02 89.99 53.04 89.59 52.54C89.35 52.25 88.93 52.13 88.8 51.76C88.59 51.2 88.82 50.48 88.74 49.89C88.67 49.38 88.1 49.27 87.88 48.86C87.67 48.48 87.83 48.04 87.63 47.66C87.47 47.34 87.13 47.24 86.93 46.95C86.68 46.58 86.84 46.15 86.67 45.75C86.5 45.33 86.04 45.23 85.84 44.85C85.67 44.53 85.67 42.59 85.8 42.24C86.22 41.08 89.57 42.26 90.43 41.61C91.22 41.01 90.33 39.7 90.94 39.01C91.54 38.32 92.77 39.13 93.45 38.6C93.94 38.21 93.61 37.58 93.9 37.1C94.3 36.45 95.16 36.07 95.58 35.44C95.81 35.09 95.68 34.72 95.79 34.35C95.9 34.01 96.27 33.78 96.43 33.48C95.34 31.88 94.81 32.68 93.99 32.02C93.43 31.58 93.03 30.81 92.44 30.42C91.96 30.11 91.35 30.39 90.92 29.96C90.11 29.17 89.39 28.16 88.5 27.47C88.04 27.11 87.43 27.39 86.98 27.01C86.43 26.56 86.02 25.8 85.42 25.41C84.98 25.13 84.43 25.36 84 25.03C83.43 24.6 83.04 23.83 82.45 23.43C82.01 23.13 81.46 23.36 81.03 23.05C80.44 22.63 80.06 21.86 79.47 21.45C79.04 21.14 78.49 21.37 78.05 21.07C77.43 20.65 77.04 19.78 76.39 19.4C75.94 19.13 75.4 19.37 74.97 19.01C74.43 18.55 74.02 17.79 73.42 17.41C73.01 17.15 72.51 17.35 72.1 17.1C71.45 16.71 71.07 15.84 70.44 15.43C70.01 15.13 69.46 15.36 69.02 15.05C68.42 14.61 68.02 13.73 67.36 13.38C66.94 13.15 66.45 13.34 66.05 13.07C65.43 12.64 65.04 11.77 64.39 11.39C64.04 11.19 63.66 11.32 63.29 11.19C62.86 11.04 62.75 10.59 62.37 10.38C61.95 10.15 61.46 10.35 61.05 10.07C60.05 9.4 59.45 8.09 58.44 7.42C58.03 7.15 57.54 7.35 57.12 7.11C56.75 6.9 56.63 6.45 56.2 6.3C55.83 6.18 55.45 6.31 55.1 6.1C54.43 5.7 54.04 4.72 53.34 4.37C52.92 4.15 52.43 4.34 52.02 4.05C51.44 3.63 51.06 2.86 50.47 2.45C50.09 2.18 49.67 2.34 49.27 2.18C48.21 1.78 48.83 1.05 47.01 1.26C46.17 1.36 45.62 2.56 44.99 3.04C44.56 3.36 44.01 3.13 43.57 3.42C42.81 3.91 41.78 5.31 41.06 5.99C40.62 6.39 40 6.11 39.53 6.44C38.95 6.85 38.56 7.62 37.98 8.05C37.55 8.36 37 8.13 36.56 8.42C35.96 8.82 35.57 9.59 35 10.03C34.54 10.39 33.94 10.11 33.48 10.48C32.93 10.93 32.53 11.7 31.93 12.08C31.45 12.39 30.85 12.11 30.41 12.54C29.93 13.02 29.29 14.06 28.61 14.22C28.18 14.32 27.68 14.25 27.24 14.25C26.9 14.25 26.44 14.33 26.13 14.15C25.17 13.58 26.21 10.53 25.58 9.57C25.36 9.22 24.62 8.46 24.23 8.32C23.79 8.15 19.15 8.16 18.74 8.33C18.33 8.5 17.87 9.09 17.55 9.41C16.92 10.03 17.25 11.75 17.25 12.58C17.25 13.87 17.46 21.17 17.15 21.81C17.01 22.1 16.76 22.21 16.53 22.42C16.28 22.64 16.16 22.97 15.85 23.13C15.39 23.37 14.84 23.13 14.43 23.52C13.93 24 13.4 24.9 12.76 25.17C12.36 25.34 11.93 25.17 11.55 25.43C10.93 25.85 10.54 26.71 9.9 27.1C9.49 27.35 8.99 27.15 8.58 27.41C7.94 27.82 7.56 28.68 6.92 29.09C6.58 29.31 6.2 29.18 5.83 29.29C5.17 29.5 4.52 30.5 4.06 31C3.75 31.32 3.26 31.89 2.89 32.11C2.37 32.41 1.49 32.02 1.28 32.79C1.14 33.33 1.06 34.92 1.36 35.39C1.6 35.75 2.04 35.86 2.19 36.3C2.37 36.8 2.08 37.47 2.74 37.71C3.56 38 5.46 37.36 6.04 37.99C6.85 38.85 5.58 40.83 6.55 41.59C7.32 42.21 9.75 41.15 10.2 42.22C10.33 42.54 10.25 43 10.25 43.34C10.25 43.76 10.33 44.3 10.19 44.7C9.89 45.59 6.14 48.48 5.42 49.56C5.17 49.94 5.34 50.37 5.17 50.77C4.99 51.17 4.54 51.3 4.35 51.69C4.16 52.08 4.33 52.52 4.1 52.9C3.9 53.23 3.48 53.34 3.32 53.69C3.03 54.27 3.42 55.06 3.2 55.67C3.09 56.01 2.71 56.24 2.54 56.55C3.21 56.99 4.73 56.31 5.17 57.16C5.33 57.48 5.33 59.58 5.14 59.88C4.92 60.25 4.47 60.35 4.31 60.78C4.16 61.19 4.32 61.61 4.04 61.98C3.82 62.29 3.39 62.39 3.28 62.78C3.11 63.41 3.44 64.17 3.2 64.78C3.04 65.18 2.53 65.28 2.33 65.66C2.01 66.27 2.44 67.12 2.2 67.76C2.04 68.21 1.44 68.3 1.29 68.76C1.07 69.43 1.14 73.33 1.26 74.13C1.43 75.17 2.76 74.37 3.17 75.16C3.47 75.74 3.26 79.51 3.25 80.4C3.24 81.17 2.36 81.21 2.26 81.89C1.98 83.87 2.25 87.59 2.25 89.76C2.25 90.65 2.01 92.47 2.3 93.26C2.74 94.47 5.62 93.06 6.18 94.17C6.62 95.07 5.93 96.36 6.3 97.28C6.5 97.76 7.16 97.83 7.24 98.4C7.38 99.49 6.93 101.29 7.3 102.27C7.47 102.71 8.06 102.8 8.21 103.26C8.41 103.88 8.08 104.63 8.29 105.25C8.43 105.63 8.85 105.73 9.07 106.05C9.32 106.42 9.16 106.85 9.33 107.25C9.49 107.66 9.95 107.78 10.14 108.17C10.35 108.6 10.2 109.06 10.43 109.46C10.75 109.3 10.97 108.93 11.31 108.8C11.84 108.61 13.28 108.61 13.79 108.84C14.05 108.96 15.92 110.81 16.09 111.09C16.4 111.57 16.11 112.17 16.56 112.6C17.08 113.11 18.04 114.26 18.6 114.6C19.04 114.87 19.59 114.64 20.01 114.98C20.57 115.43 20.97 116.19 21.57 116.58C21.95 116.83 22.38 116.66 22.78 116.84C23.25 117.04 23.37 117.68 23.92 117.74C24.54 117.81 25.63 117.49 26.08 118.03C26.77 118.87 25.56 122.44 26.81 122.73C28.04 123.01 30.81 122.75 32.19 122.75L43.69 122.75C44.53 122.75 48.99 122.93 49.41 122.62C50.54 121.81 48.94 116.33 50.22 115.8C50.68 115.61 53.2 115.64 53.71 115.78C53.94 115.84 54.16 116.06 54.22 116.29C54.43 117.09 53.89 119.05 54.53 119.58C54.85 119.85 60.63 119.9 61.23 119.71C62.39 119.35 61.26 116.75 61.95 115.99C62.78 115.1 64.92 116.47 65.63 115.4C66.04 114.78 65.5 113.83 65.82 113.18C65.99 112.83 66.41 112.72 66.61 112.39C66.81 112.04 66.68 111.66 66.81 111.3C66.96 110.86 67.41 110.75 67.62 110.37C67.83 109.99 67.67 109.55 67.87 109.16C68.08 108.75 68.65 108.63 68.73 108.14C68.95 106.91 68.42 105.46 68.79 104.27C68.94 103.77 69.63 103.69 69.73 103.15C69.85 102.55 69.5 101.58 69.89 101.06C70.3 100.54 72.07 100.61 72.66 100.79C73.54 101.06 73.92 102.36 74.77 102.68C75.24 102.86 77.79 102.88 78.26 102.7C78.63 102.57 78.74 102.14 79.05 101.93C79.43 101.67 79.86 101.84 80.26 101.67C80.86 101.42 81.78 100.34 81.69 99.7Z"></path><path class="hp-d" fill-rule="evenodd" d="M47.68 7.1C51.8 9.47 55.7 12.39 59.66 15.01L83.84 31.04L89.29 34.77L90.39 35.36C90.99 35.85 93.24 37.65 93.92 37.64C94.79 37.62 96.54 34.41 96.69 33.57C96.09 32.14 94.18 31.27 92.92 30.44L83.76 24.34L59.62 8.27C55.82 5.74 51.71 2.58 47.76 0.41C46.72 1.7 42.25 4.34 40.63 5.45L30.73 12.23C29.23 13.25 27.7 14.57 26.09 15.34L25.64 14.94C25.24 13.28 25.81 10.23 25.6 8.35L17.1 8.35C16.97 12.8 17.14 17.26 17.09 21.71C15.66 22.13 13.69 23.9 12.4 24.78C10.11 26.35 1.07 32.08 0.05 33.68C0.18 34.03 0.48 34.07 0.71 34.44C1.32 35.44 1.55 36.92 2.51 37.67C3.7 37.87 4.66 36.6 5.61 36.04C6.99 35.21 8.25 34.16 9.56 33.22L10.46 32.8L13.62 30.57L37.05 14.55C39.08 13.16 46.54 8.52 47.68 7.1ZM41.08 115.87C40.86 115.03 42.44 113.5 42.85 112.61C44.27 109.52 44.85 106.05 44.68 102.65C44.66 102.09 44.79 101.56 44.42 101.09C44.2 100.79 43.84 100.58 43.48 100.52L42.24 100.64L37.74 100.62L21.36 100.69C19.42 100.69 16.59 101.26 15.26 99.44C14.32 98.16 14.94 93.59 14.9 91.89L14.8 79.27C14.82 77.51 14.43 75.36 15.06 73.68C15.26 73.14 16.2 72.42 16.74 72.24C17.56 71.96 22.12 71.92 22.8 72.27C23.75 73.66 22.37 84.25 23.24 85.76C24.04 86.26 26.33 86.25 27.07 85.65C27.46 84.72 27.18 77.07 27.18 75.44C27.18 74.53 26.82 72.55 27.37 71.95C29.13 71.53 29.05 73.85 29.05 74.96C29.05 76.62 28.74 84.91 29.23 85.78C30.16 86.35 35.94 86 37.42 86C38.26 86 39.25 86.22 39.95 85.69C40.42 84.63 40.07 81.88 40.07 80.6C40.07 79.16 40.39 74.43 40.02 73.36C39.86 72.9 39.48 72.64 39.24 72.24L37.23 68.25L36.81 66.68L35.18 62.63L34.77 61.07C34.43 60.2 33.75 59.39 33.67 58.45C34.44 57.59 39.63 58 41.01 58L58.89 58C60.43 58.01 64.52 57.55 65.68 58.33C66.1 59.06 65.96 60.04 66.22 60.86C66.98 63.26 68.07 65.59 68.76 68.02C69.06 69.09 69.03 70.58 69.73 71.49C70.42 72.38 72.7 71.92 73.71 71.92L83.21 71.92C84.27 71.91 85.99 72.26 86.89 71.68C87.21 70.98 86.79 70.22 87.26 69.56C88.68 69.51 89.32 71.67 90.66 71.82C91.43 71.28 90.89 68.44 90.62 67.54C89.74 64.63 89.08 61.66 87.8 58.91C87.39 58.02 86.09 56.69 86.42 55.71C88 55.49 89.12 57.32 90.64 57.25C91.57 56.29 90.36 54.97 90.14 53.91C89.93 52.93 89.47 52.16 89.14 51.23C88.45 49.33 87.78 47.4 86.82 45.61C86.32 44.68 84.74 43.08 85.03 42.08C86.28 41.02 90.94 43.12 91.13 40.73C91.22 39.46 89.67 38.82 88.82 38.2C86.26 36.32 83.47 34.45 80.75 32.82L78.54 31.21L72.54 27.18C64.26 21.78 56.02 16.09 47.78 10.53C46.35 11.77 44.63 12.82 43.05 13.91L34.62 19.74L23.71 27.21C21 28.99 18.5 31.05 15.76 32.77C13.83 33.98 12.09 35.49 10.18 36.73L7.75 38.24C6.97 38.77 5.5 39.77 5.69 40.88C6.08 43.15 10.75 40.84 11.77 42.07C11.78 42.31 11.83 42.45 11.67 42.66L10.58 43.49L8.63 45.43C6.8 47.27 3.6 51.99 3.05 54.46C2.85 55.35 2.03 56.26 2.39 57.12C3.96 57.77 5.31 55.27 6.83 55.86C7.12 56.78 5.33 58.57 4.88 59.56C3.55 62.53 1.69 65.61 1.13 68.88C0.9 70.23 1.21 72.76 0.05 73.54L0.09 75.5C2.01 75.1 3.23 72.13 4.64 72.11C4.82 72.33 4.94 72.44 4.88 72.76C4.81 73.17 4.47 73.49 4.31 73.87L3.2 77.18L2.88 79.4L2.16 82.57C1.82 84.99 1.73 87.75 2 90.18C2.12 91.27 1.75 93.4 2.7 94.08C4.46 93.48 3.98 90.58 5.53 89.64C6.37 90.13 5.82 93.24 5.89 94.29C6.14 98.08 7.22 102.88 8.73 106.36C9.05 107.08 9.91 109.85 10.31 110.28C10.55 110.53 10.81 110.49 11.12 110.47C11.95 109.44 11.14 106.94 12.43 106.26C13.16 106.65 13.03 107.61 13.48 108.28C14.74 110.12 15.8 111.98 17.4 113.58C18.34 114.53 20.59 116.34 21.79 116.85C22.7 117.23 24.82 117.7 25.46 118.37C26.52 119.46 24.84 121.98 26.97 122.96C28.17 123.51 30.8 123.15 32.19 123.15L44.31 123.15C45.46 123.15 49.31 123.74 49.31 122.15C49.31 119.26 46.93 116.9 44.21 116.32C43.27 116.12 41.8 116.46 41.08 115.87ZM15.35 43.87C15.11 43.27 15.96 42.02 16.44 41.55C17.48 40.54 21.28 35.25 23.1 37.32C23.76 38.08 23.23 39.16 22.61 39.76C21.39 40.93 19.71 41.34 18.29 42.18C17.52 42.63 16.46 43.57 15.7 43.89L15.35 43.87ZM81.56 43.83C81.11 43.84 74.93 40.28 74.28 39.73C73.57 39.13 73 38.21 73.71 37.39C74.51 36.47 75.88 37.11 76.63 37.71C77.96 38.78 81.69 42.09 81.56 43.83ZM19.94 52.05C19.32 50.85 22.99 45.62 24.66 47.29C24.73 47.61 24.76 47.81 24.6 48.12C24.15 48.98 20.77 52.02 19.94 52.05ZM72.29 47.25C73.97 45.74 77.47 50.77 76.93 52.06L76.33 52.03L75.57 51.21C74.53 50.36 71.74 48.85 72.29 47.25ZM9.7 59.13C9.43 57.6 12.17 53.23 13.3 52.08C14.07 51.29 15.14 50.4 16.14 51.36C16.35 51.95 16.22 52.47 15.92 53.02C14.93 54.83 12.99 56.18 11.57 57.64L10.62 58.8L9.7 59.13ZM17.44 65.33C16.75 64.17 21.35 56.66 23.3 58.18C24.22 58.9 23.42 59.87 22.96 60.57C22.49 61.28 18.11 65.15 17.44 65.33ZM83.57 66.75C83.24 66.56 79.31 61.03 79.07 60.43C78.73 59.58 78.51 58.55 79.28 57.92C81.54 57.48 82.86 62.56 83.32 64.13C83.57 64.98 84.37 66.01 83.57 66.75ZM8.31 73.97C7.54 73.08 8.31 72.12 8.66 71.23L9.28 68.94C9.85 67.58 11.88 63.63 13.74 65.07C14.55 66.7 10.88 70.19 10.08 71.67C9.72 72.34 8.99 73.74 8.31 73.97ZM9.46 88.68C8.23 87.59 9.82 81.43 10.58 80.08C11.05 79.24 11.43 78.05 12.6 78.27C13.93 79.73 11.76 83.05 11.19 84.53C10.92 85.25 10.92 85.98 10.51 86.65C10.11 87.31 10.12 88.29 9.46 88.68ZM71.55 86.21C71.34 86.33 71.21 86.34 71.15 86.62C70.99 87.34 71.02 92.31 71.09 93.22C71.12 93.5 71.23 93.55 71.41 93.71C71.68 93.63 71.83 93.62 71.93 93.29C72.1 92.74 72.16 87.06 72 86.57C71.91 86.31 71.76 86.3 71.55 86.21ZM12.44 99.01C11.25 98.16 11.21 91 13.65 91.67C13.9 91.98 14.04 92.27 14.02 92.69L13.82 93.54L13.15 95.82C13.02 96.64 13.12 97.51 12.91 98.31L12.44 99.01ZM61.82 119.79C62.42 118.7 61.53 117.22 62.23 116.17C62.9 115.82 63.71 116.17 64.37 115.71C65.97 114.59 68.16 110.13 68.76 108.25C69.06 107.28 69.23 106.06 69.32 105.05C69.41 104.06 70.58 101.1 69.24 100.62C68.52 100.36 66.63 100.33 66.17 101.04C65.54 102.01 65.28 103.2 64.82 104.24C63.85 106.42 62.25 108.5 60.72 110.32C59.33 111.98 57.61 113.34 55.91 114.65C55.4 115.03 54.8 115.21 54.38 115.71C53.74 116.47 53.72 118.98 54.19 119.8C54.86 120.19 61.17 120.19 61.82 119.79Z"></path><g class="hp-foot" transform="rotate(-0.87 57 119.5)"><path class="hp-d" fill-rule="evenodd" d="M72.78 122.79C73.65 121.23 71.45 118 70.06 117.22C69.28 116.77 68.26 116.38 67.38 116.23C66.47 116.07 65.55 116.19 64.63 116.15C61.81 116 58.98 116 56.14 116C55.3 116 54.2 115.82 53.41 116.17C53 116.37 52.68 116.74 52.24 116.89C51.7 117.07 50.87 117.1 50.75 117.81C50.68 118.2 51.65 121.87 51.86 122.4L52.24 122.88C52.8 123.21 56.23 123 57.09 123L68.34 123C69.44 123 71.91 123.3 72.78 122.79Z"></path></g><g class="hp-head" transform="rotate(1.67 48.5 60)"><path class="hp-l" d="M34.8 61.6C34.71 61.33 34.51 60.6 34.25 60C33.99 59.4 33.62 58.83 33.25 58C32.88 57.17 32.38 56 32 55C31.62 54 31.18 53 30.95 52C30.72 51 30.68 50.17 30.6 49C30.53 47.83 30.48 46.33 30.5 45C30.52 43.67 30.6 42.45 30.7 41C30.8 39.55 31.03 37.08 31.1 36.3C30.88 36.04 30.14 35.26 29.75 34.75C29.36 34.24 29.04 33.81 28.75 33.25C28.46 32.69 28.15 32.02 28 31.4C27.85 30.77 27.8 30.17 27.85 29.5C27.9 28.83 28.04 27.98 28.3 27.4C28.56 26.82 28.95 26.31 29.4 26C29.85 25.69 30.48 25.57 31 25.55C31.52 25.53 32.05 25.67 32.5 25.9C32.95 26.12 33.35 26.53 33.7 26.9C34.05 27.27 34.34 27.72 34.6 28.1C34.86 28.48 35.14 29.02 35.25 29.2C35.41 29.03 35.81 28.52 36.2 28.2C36.59 27.88 37.08 27.51 37.6 27.3C38.12 27.09 38.68 27.01 39.3 26.95C39.92 26.89 40.68 26.88 41.3 26.95C41.92 27.02 42.47 27.12 43 27.35C43.53 27.58 44.01 27.93 44.5 28.35C44.99 28.77 45.48 29.3 45.95 29.85C46.43 30.4 46.93 31.13 47.35 31.65C47.77 32.17 48.27 32.73 48.45 32.95C48.62 32.73 49.09 32.11 49.5 31.6C49.91 31.09 50.43 30.42 50.9 29.9C51.37 29.38 51.8 28.86 52.3 28.45C52.8 28.04 53.35 27.69 53.9 27.45C54.45 27.21 55.03 27.06 55.6 27C56.17 26.94 56.77 27 57.3 27.1C57.83 27.2 58.32 27.38 58.8 27.6C59.28 27.82 59.79 28.13 60.2 28.4C60.61 28.67 61.08 29.07 61.25 29.2C61.36 28.98 61.62 28.31 61.9 27.9C62.17 27.49 62.5 27.05 62.9 26.75C63.3 26.45 63.83 26.21 64.3 26.1C64.77 25.99 65.27 26 65.7 26.1C66.13 26.2 66.56 26.4 66.9 26.7C67.24 27 67.56 27.38 67.75 27.9C67.94 28.42 68.05 29.12 68.05 29.8C68.05 30.48 67.92 31.34 67.75 32C67.58 32.66 67.29 33.25 67 33.75C66.71 34.25 66.33 34.59 66 35C65.67 35.41 65.17 36 65 36.2C65.06 36.83 65.24 38.53 65.35 40C65.46 41.47 65.57 43.33 65.65 45C65.73 46.67 65.82 48.33 65.85 50C65.88 51.67 65.79 53.33 65.8 55C65.81 56.67 65.84 58.9 65.9 60C65.96 61.1 66.11 61.33 66.15 61.6Z"></path><g class="hp-eyes" transform="translate(2.14 0.96)"><ellipse class="hp-d hp-eye" cx="39.85" cy="39.15" rx="2.45" ry="3.45"></ellipse><ellipse class="hp-d hp-eye" cx="57.35" cy="39.15" rx="2.45" ry="3.45"></ellipse></g><g class="hp-muzzle" transform="translate(1.11 0.55)"><path class="hp-d" d="M48.6 43.6C50.7 43.6 51.85 44.55 51.85 46.05C51.85 47.45 50.7 48.35 49.5 49.25L49.4 51.9L47.8 51.9L47.7 49.25C46.5 48.35 45.35 47.45 45.35 46.05C45.35 44.55 46.5 43.6 48.6 43.6Z"></path><path class="hp-s" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" d="M43.2 51C43.75 52.35 44.85 52.95 46 52.95C47.2 52.95 48.2 52.5 48.6 51.75C49 52.5 50 52.95 51.2 52.95C52.35 52.95 53.45 52.35 54.05 51"></path></g></g><g class="hp-plank" transform="translate(0 0) rotate(0 46 86)"><g class="hp-lift" transform="rotate(-7.87 35 76)"><rect class="hp-l" x="16.6" y="74.3" width="83.5" height="24.1"></rect><path class="hp-d" fill-rule="evenodd" d="M75.77 98.72C76.11 97.68 76.33 98.25 76.89 97.53C76.11 96.82 74.71 96.83 73.69 96.72L70.45 96.49L68.7 96.56L65.79 95.88L63.91 95.2C63.2 95 62.41 94.99 61.72 94.7L60.5 94.07C59.65 93.8 58.68 93.76 57.8 93.57L56.24 93.13C53.78 92.88 51.21 92.88 48.76 93.19C46.74 93.45 44.87 93.86 42.81 93.76C41.57 93.69 40.44 93.38 39.23 93.19L34.88 92.76C33.5 92.63 32.18 92.34 30.78 92.39C29.9 92.42 29.07 92.68 28.19 92.77C26.72 92.93 25.16 92.81 23.72 93.21C22.79 93.47 19.27 94.52 18.54 94.46C18.24 94.08 18.21 93.68 18.16 93.19C17.93 91 21.56 91.22 22.92 90.88C27.16 89.85 31.77 90.09 36.1 90.35C37.32 90.42 40.74 91.15 41.62 90.48C41.06 88.36 37.56 89 35.92 88.97C31.88 88.91 27.83 88.69 23.8 89.04C22.14 89.18 20.11 90.51 18.44 89.95C18 89.31 18.01 86.38 18.51 85.77C19 85.62 21.85 86.07 22.57 86.18C25.41 86.61 28.12 86.99 31.01 86.99C32.12 86.99 34.16 87.34 35 86.55C35.1 84.93 33.12 85.3 32.06 85.34C30.78 85.38 29.47 85.44 28.19 85.34L26.09 85.05C24.63 84.94 23.17 84.89 21.74 84.6C20.64 84.37 16.95 84.21 18.46 82.28C19.86 81.75 23.06 82.66 24.62 82.84L28.11 83.09C29.06 83.14 30.96 83.55 31.5 82.62C31.13 81.75 29.72 82.09 28.91 81.97L25.93 81.67L24.36 81.26L21 80.97C19.92 80.92 17.41 81 18.3 79.2C19.48 78.55 22.43 79.56 23.81 79.71L26.43 79.79C27.35 79.8 29.31 80.01 28.8 78.54C28.18 78.08 27.04 78.4 26.27 78.4C24.43 78.41 22.64 78.08 20.81 77.93C19.8 77.85 18.15 77.78 18.32 76.42L18.81 76.07C19.47 75.92 20.14 76.11 20.81 76.12L25.43 76.12C26.01 76.11 27.18 76.33 27.62 75.88C28.19 75.3 27.85 74.57 27.67 73.96L16.3 73.96C16.12 82.2 16.29 90.46 16.29 98.7C18.52 98.82 20.79 98.72 23.02 98.72L36.02 98.72L75.77 98.72ZM99.69 98.68C99.78 98.07 99.79 98.06 100.4 98.01C100.53 96.46 100.43 94.85 100.43 93.29L100.43 84.16L100.43 77.41C100.43 76.28 100.54 75.06 100.38 73.96L43.39 73.96C43.35 76.65 47.14 76.03 48.89 76.02C53.43 76.02 57.98 76.15 62.51 75.98C63.61 75.94 66.55 75.53 67.17 76.44C66.68 77.01 64.75 77.31 63.93 77.53C60.6 78.44 57.18 79.15 53.72 78.71C52.52 78.56 48.94 77.55 48.19 78.46C48.62 79.56 50.27 79.76 51.31 79.89C53.94 80.22 58.51 80.56 61.01 79.78L63.16 79.13L64.89 78.87L65.88 78.36L67.57 77.89L68.91 77.24C69.67 76.99 70.47 76.96 71.24 76.78L72.77 76.25C75.01 75.83 79.12 75.69 81.38 75.95C82.31 76.06 83.01 76.46 83.87 76.72L86.07 77.21L87.06 77.73L89.12 78.22L90.76 78.82C92.42 79.21 94.3 79.09 96 79.05C96.7 79.03 97.55 78.88 98.24 79.07L98.62 79.37C98.7 81.05 96.03 80.86 94.91 80.85C93.26 80.84 91.84 80.48 90.24 80.12L88.53 79.8L87.04 79.15L85.45 78.83C84.72 78.6 84.16 78.14 83.37 78.01C78.87 77.29 75.49 78.06 71.34 79.68L69.77 80.12L68.44 80.8L66.97 81.09L65.34 81.72C63.75 82.1 62.13 82.08 60.53 82.45C58.79 82.86 56.7 82.67 54.92 82.6L53.68 82.47L53.14 82.75C52.98 83.13 52.98 83.29 53.14 83.68C54.05 84.38 57.42 84.04 58.67 84.02C60.75 83.99 62.7 83.55 64.73 83.21C65.51 83.08 66.31 83.06 67.07 82.84C68.42 82.43 69.7 81.78 71 81.28L72.46 80.92L75.41 79.94L76.93 79.4C81.2 78.48 83.12 79.51 86.99 80.78L89.19 81.25L90.59 81.79C92.18 82.27 94.79 82.2 96.44 82.01C97.22 81.92 98.29 81.57 98.61 82.48C98.29 83.24 96.64 83.51 95.85 83.58C93.42 83.8 92.56 83.48 90.28 83.12C89.35 82.97 88.35 83 87.45 82.66C84.85 81.68 81.45 80.91 78.66 81.18C77.91 81.25 77.21 81.53 76.48 81.71L74.64 82.06L73.05 82.78L71.6 83.13L68.2 84.68C67.43 84.98 66.56 84.95 65.75 85.14L63.59 85.75C61.77 86.13 58.07 86.22 56.11 86.25C55.26 86.27 54.18 85.98 53.4 86.28C53.08 86.73 53.07 87.04 53.35 87.51C54.58 88.19 58.31 87.56 59.78 87.37L64.51 86.98C65.77 86.8 67.26 86.33 68.49 85.96L69.83 85.31L71.41 84.91L72.75 84.25L74.32 83.82L75.68 83.21C78.43 82.48 81.74 82.56 84.5 83.17L86.74 83.94L88.71 84.26C91.39 84.94 92.34 85.04 95.11 85.06C95.9 85.07 97.57 84.65 98.2 84.93C98.98 85.28 98.78 86.98 98.52 87.59C97.71 88.11 95 87.7 93.85 87.78C92.85 87.86 91.72 87.91 90.75 88.2L89.23 88.75L87.01 89.11L84.36 89.84C83.21 90.08 81.56 89.74 80.61 90.46C81.12 92.09 83.1 91.45 84.31 91.2L86.53 90.87L88.54 90.19L90.51 89.87C91.78 89.61 93 89.16 94.3 89.12C95.5 89.09 99.13 88.53 98.55 90.61C97.65 91.29 95.99 90.81 94.9 90.87C93.55 90.94 92.1 90.84 90.78 91.13L88.52 91.85C87.63 92.07 86.86 92.15 86.01 92.52C85.24 92.86 84.17 92.82 83.67 93.53C83.97 95.15 86.33 93.93 87.28 93.51C88.16 93.12 89.13 93.05 90.07 92.86L91.73 92.34C93.02 92.04 94.41 92.02 95.72 92.02C96.59 92.03 97.96 91.75 98.53 92.52C98.38 93.79 96.9 93.19 96.04 93.15C94.95 93.1 90.18 93.87 89.55 94.51C89.92 95.19 91.21 95.05 91.94 95C93.35 94.92 97.73 94.28 98.65 95.31C98.8 96.87 96.22 96.34 95.24 96.36L87.74 96.4C86.82 96.39 85.46 96.11 84.68 96.7C84 97.22 84.38 98.09 84.6 98.72L94.6 98.72C96.27 98.72 98.04 98.87 99.69 98.68ZM87.63 76.38C88.13 75.76 89.31 75.86 90.08 75.87C91.5 75.9 97.86 75.62 98.58 76.31C98.77 77.69 97.14 77.63 96.19 77.71C94.76 77.83 93.24 77.83 91.83 77.56L90.12 77.17C89.37 77.08 88.02 77.05 87.63 76.38ZM86.99 86.42C86.63 85.77 84.45 85.15 83.65 84.96C80.46 84.22 80.42 83.83 77.09 84.8C76.22 85.05 75.42 85.2 74.61 85.64C73.96 86 73.2 85.89 72.79 86.55C73.16 87.49 74.57 87.61 75.46 87.87C79.02 88.92 80.11 89.14 83.76 88.09C84.72 87.8 86.83 87.6 86.99 86.42ZM76.76 86.46C77.69 85.46 82.59 85.43 83.45 86.49C82.84 87.45 77.25 87.51 76.76 86.46ZM76.1 90.47C75.12 89.16 72.3 89.04 70.79 88.66C69.73 88.39 68.89 88 67.76 88.01C66.95 88.02 65.73 87.86 65.18 88.5C65.39 89.36 67.08 89.33 67.89 89.45L71.42 90.23C72.9 90.65 74.74 91.76 76.1 90.47ZM71.67 93.68C71.61 93.45 71.62 93.3 71.4 93.16C70.9 92.83 70.13 92.91 69.57 92.77L67.6 92.02L65.89 91.63L64.64 91.08L62.92 90.8L60.53 90.07C58.89 89.72 56.99 89.64 55.31 89.6C54.15 89.58 50.84 89.18 50.57 90.63C51.27 91.42 54.98 91.03 56.16 91.06C59.17 91.13 62.09 91.94 64.92 92.84C65.91 93.15 66.82 93.25 67.77 93.7C68.71 94.14 71.09 94.81 71.67 93.68ZM18.95 96.45C19.28 96.1 19.66 95.99 20.1 95.79C21.71 95.02 22.51 95.16 24.18 94.85C25.31 94.64 26.32 94.3 27.47 94.18C30.41 93.87 33.51 93.85 36.45 94.24C37.82 94.42 38.86 94.9 40.35 95C43.33 95.19 46.5 95.16 49.46 94.82L51.92 94.35C53.7 94.18 55.22 94.71 56.96 94.94C57.75 95.05 58.55 94.97 59.32 95.19C59.98 95.39 61.11 96.01 61.47 96.52C60.8 96.84 53.54 96.56 52.16 96.56L28.8 96.59C26.43 96.59 24.05 96.54 21.68 96.67C20.83 96.72 19.58 97.09 18.95 96.45Z"></path><g class="hp-paws"><path class="hp-l" d="M47.78 89.94C51.47 89.72 53.31 85.51 51.41 82.47C50.34 80.77 48.39 80.2 46.87 79.04C46.13 78.47 45.3 77.94 44.64 77.28C43.83 76.47 42.22 74.38 41.33 73.97C39.92 73.31 34.9 73.65 33.11 73.65C32.14 73.65 29.08 73.41 28.48 74.19C27.88 74.96 28.95 76.14 29.28 76.8C30.23 78.74 31.35 80.58 32.73 82.25L33.29 82.75L33.83 83.43C34.54 83.99 35.08 84.76 35.81 85.3C39.2 87.8 43.39 90.2 47.78 89.94Z"></path><path class="hp-d" fill-rule="evenodd" d="M28.76 72.44C28.79 74.15 30.05 75.98 30.84 77.45L31.19 78.38C31.62 79.12 32.24 79.81 32.76 80.48C34.58 82.78 36.55 84.72 39.08 86.24L39.79 86.75L40.97 87.17C41.48 87.38 41.86 87.72 42.41 87.9C45.11 88.79 48.79 90.17 50.72 87.2C51.08 86.64 51.03 86.01 51.07 85.38C51.18 83.38 50.2 82.18 48.51 81.18L47.58 80.84L45.96 79.68C44.2 78.43 42.61 76.9 41.27 75.21C40.62 74.39 39.86 72.59 38.95 72.15C38.15 71.77 34.35 72 33.23 72C32.14 72 29.46 71.67 28.76 72.44Z"></path><circle class="hp-d" cx="77.1" cy="98.1" r="5.15"></circle></g></g></g></g>' + "</svg>";

  // Avausnappi: Hattibotti-aave Hattulan Puun väreillä (#a9dd9a + #2b3827)
  var GHOST_SVG =
    '<svg class="ghost" viewBox="0 0 100 140" aria-hidden="true" focusable="false"><circle cx="6.5" cy="86" r="6.3" fill="#2b3827"/><circle cx="93.5" cy="86" r="6.3" fill="#2b3827"/><path d="M10 127 L10 56 C10 26 27 6 50 6 C73 6 90 26 90 56 L90 127 C90 135.5 83 138 77.5 132 L71.5 125 C67.5 120.5 62 120.5 58 125 L52.5 131.5 C51 133.3 49 133.3 47.5 131.5 L42 125 C38 120.5 32.5 120.5 28.5 125 L22.5 132 C17 138 10 135.5 10 127 Z" fill="#a9dd9a" stroke="#2b3827" stroke-width="4.6" stroke-linejoin="round"/><g class="eyes" fill="#ffffff" stroke="#2b3827" stroke-width="4"><circle cx="32" cy="46" r="13"/><circle cx="68" cy="46" r="13"/></g><g class="pupils" fill="#2b3827"><circle class="pu" cx="32" cy="46.5" r="4.6"/><circle class="pu" cx="68" cy="46.5" r="4.6"/></g><path transform="translate(19 80) scale(1.9130)" fill-rule="evenodd" fill="#2b3827" d="M0 11.5L4.2 0H7.8L12 11.5H8.6L7.85 9.25H4.15L3.4 11.5ZM4.95 6.75H7.05L6 3.45ZM13.9 0H17.4V11.5H13.9Z"/><g fill="none" stroke="#2b3827" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"><path d="M57.5 88.5V102"/><circle cx="61.2" cy="98" r="4"/><circle cx="71.2" cy="98" r="4"/><path d="M79.2 91.5V99.2C79.2 101.4 80.6 102.3 82.8 102"/><path d="M77 94.4H82.4"/></g></svg>';

  // Merkki botin nimen vieressä otsikossa
  var BOT_IQ = "Älykäs";
  var BOT_IQ_NOTE = "Kehityn paremmaksi tulevaisuudessa";

  var ICON_X =
    '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  var ICON_TRASH =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12M9 7V4h6v3"/></svg>';
  var ICON_PHONE =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2"/></svg>';
  var ICON_PERSON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>';
  var ICON_BACK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
  var ICON_CLIP =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.5 11.2l-8.4 8.4a5.2 5.2 0 0 1-7.4-7.4l8.4-8.4a3.5 3.5 0 0 1 5 5l-8.4 8.4a1.8 1.8 0 0 1-2.5-2.5l7.7-7.7"/></svg>';
  var ICON_DOC =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"/><path d="M14 3v5h5M9 13h6M9 17h6"/></svg>';
  var ICON_PLAN =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/><path d="M10 20v-6h4v6"/></svg>';
  var ICON_TRUCK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2z"/><path d="M13 9h4l4 4v3h-8z"/><circle cx="6.5" cy="17.5" r="2"/><circle cx="17.5" cy="17.5" r="2"/></svg>';
  var ICON_SEND =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"/></svg>';
  var ICON_CLOSE =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  var GREETING =
    "Hei! Olen **Hattibotti**, Hattulan Puun avustaja. Kysy tuotteista, hinnoista, toimituksen hinnasta tai noudosta. Voit myös lähettää kuvia, niin etsin vastaavat tuotteet valikoimasta, tai PDF-piirustuksia, niin lasken niistä materiaalit (enintään 3 liitettä kerralla).";
  var CHIPS = [
    { label: "Tunnista tuote kuvasta", image: true },
    { label: "Terassin materiaalit", prkl: "terassi" },
    { label: "Rakenna pihavarasto", prkl: "prkl" },
    { label: "Levysahaus", levy: true },
    { label: "Toimituksen hinta", freight: true },
    { label: "Peräkärryn vuokra", trailer: true },
    { label: "Nouto", text: "Miten tuotteiden nouto varastolta toimii?" },
    { label: "Peru tilaus", cancel: true },
  ];
  // "Levysahaus" vie levysahauslaskuriin ja näyttää siellä valmiin ohjeen (ei Claude-kutsua)
  var LEVY_WELCOME =
    "Tässä on **levysahauslaskuri**. Sillä saat heti sahaussuunnitelman ja hinta-arvion mittaan sahatuille levyille.\n\n" +
    "1. Valitse **Levylaji** ja **Paksuus**. Suosituimmat ovat 2-laadun filmivaneri ja koivuvaneri.\n" +
    "2. Kirjoita kohtaan **Tarvitsemasi palat** jokaisen palan leveys ja pituus millimetreinä sekä kappalemäärä. **+ Lisää pala** lisää rivin.\n" +
    "3. Jos syysuunnalla ei ole väliä, valitse **Palat saa kääntää 90°**, niin hukkaa tulee yleensä vähemmän. **Sahaa tehdasreunat pois** antaa paloille puhtaat reunat.\n" +
    "4. Tarkista **Sahaussuunnitelma** ja **Hinta-arvio** ja lähetä ne meille **Lisää tarjouspyyntöön** -napilla.\n\n" +
    "Sahaamme suorat 90° palat ±2 mm tarkkuudella. Kipsi-, huoko- ja kuitulevyjä emme sahaa. Kysy, jos tarvitset apua!";
  var LEVY_CHIPS = [
    { label: "Mitä levyjä saa paloina?", text: "Mitä levyjä saa ostaa paloina levysahauslaskurilla?" },
    { label: "Kauanko sahaus kestää?", text: "Kauanko levyjen sahaus kestää?" },
    { label: "Auta palojen mitoissa", text: "Auta minua levysahauslaskurin palojen mitoissa." },
  ];
  // Levysahaussivulla aloitusvalinnoissa Levysahaus-nappi näkyy ohjeena
  var LEVY_CHIP = { label: "Levysahauslaskurin ohje", levy: true };
  // "Peru tilaus": tilausnumero ja puhelinnumero → palvelin välittää peruutuspyynnön myyjille
  var CANCEL_INTRO =
    "Voin välittää tilauksen peruutuspyynnön myyjälle. Kerro **tilausnumero** (löytyy tilausvahvistuksesta) ja **puhelinnumerosi**. Myyjä tarkistaa tilauksen ja vahvistaa peruutuksen.";
  // "Peräkärryn vuokra": ensin hinnat ja tarjouspyyntö, sitten (jos asiakas haluaa) puhelinnumero, päivä ja kellonaika.
  // Hinnat ja aukiolopäivät tulevat palvelimelta (hello → trailer); alla varaarvot, jos tietoja ei saatu.
  var TRAILER_DEFAULTS = { hinta: 10, aika: "3 tuntia tai seuraavan päivän aamuun", liinat: 5, tarjous_url: "https://hattulanpuu.fi/pages/tarjouspyynto" };
  var TRAILER_FORM_INTRO =
    "Kerro **puhelinnumerosi** sekä **päivä ja kellonaika**, jolloin haluat hakea kärryn. Myyjä soittaa ja vahvistaa varauksen.";
  var WEEKDAYS_ESS = ["sunnuntaina", "maanantaina", "tiistaina", "keskiviikkona", "torstaina", "perjantaina", "lauantaina"];
  // "Terassin materiaalit" vie PRKL-laskuriin, jossa terassin materiaalit lasketaan
  var TERRACE_WELCOME =
    "Terassin materiaalit lasket helpoimmin **PRKL-laskurilla**: se laskee laudat, runkopuut, palkit, kantojalat ja portaat ja tekee sahausohjeen, piirustuksen ja hinnan.\n\n" +
    "Valitse alussa **TERASSI** ja anna terassin muoto ja mitat. Lautoja, runkoa ja värejä voi vaihtaa listasta. Neuvon mielelläni missä vaiheessa tahansa. " +
    "Jos sinulla on piirustus, esimerkiksi asemapiirros PDF:nä, lähetä se tänne, niin teen siitä suunnitelman laskuriin.";
  var TERRACE_CHIPS = [
    { label: "Neuvo terassin alkuun", text: "Neuvo, miten lasken terassin materiaalit PRKL-laskurilla." },
    { label: "Mikä terassilauta?", text: "Mikä terassilauta kannattaa valita?" },
    { label: "Lähetä piirustus (PDF)", file: true },
  ];
  // "Toimituksen hinta": lomake postinumerolle ja painolle
  var FREIGHT_INTRO =
    "Lasken toimituksen hinnan. Kerro **postinumero** ja tuotteiden **paino**. Jos et tiedä painoa, jätä se tyhjäksi ja kirjoita tuotteet ja määrät viestikenttään, niin arvioin painon.";
  // PRKL-laskurin sivulla näytettävä opastus
  var PRKL_WELCOME =
    "Tässä on **PRKL-laskuri**. Sillä suunnittelet pihavaraston, aitan, saunan, autokatoksen, terassin tai pergolan 3D:nä ja saat materiaalilistan, sahausohjeen ja hinnan.\n\n" +
    "Aloita valitsemalla **PIHARAKENNUS** ja sopiva malli, ja muokkaa mittoja 3D-näkymässä. Neuvon mielelläni missä vaiheessa tahansa. " +
    "Jos sinulla on piirustus, esimerkiksi asemapiirros PDF:nä, lähetä se tänne, niin teen siitä suunnitelman laskuriin.";
  var PRKL_CHIPS = [
    { label: "Neuvo alkuun", text: "Neuvo, miten pääsen alkuun PRKL-laskurin kanssa." },
    { label: "Lähetä piirustus (PDF)", file: true },
    { label: "Mitä laskuri laskee?", text: "Mitä PRKL-laskuri laskee ja miten saan siitä tilauksen tehtyä?" },
  ];
  var PLAN_OPENED =
    "Avasin suunnitelman PRKL-laskuriin. Tarkista mitat 3D-näkymästä, sijainnit **SIJOITTELU**-painikkeesta ja korot **MAASTO**-painikkeesta. Kysy, jos haluat muuttaa jotain!";

  // ------------------------------------------------------------------
  // DOM
  // ------------------------------------------------------------------
  var host = document.createElement("div");
  host.id = "hattibotti";
  var root = host.attachShadow({ mode: "open" });
  root.innerHTML =
    "<style>" + CSS + "</style>" +
    '<div class="hb">' +
    '<div class="teaser" hidden>Kysy Hattibotilta</div>' +
    '<button class="launch" type="button" aria-label="Avaa Hattibotti-chat" aria-expanded="false" aria-controls="hb-panel">' +
    GHOST_SVG +
    '<span class="x">' + ICON_X + "</span>" +
    '<span class="badge" hidden></span></button>' +
    '<section class="panel" id="hb-panel" role="dialog" aria-label="Hattibotti-chat" hidden>' +
    "<header>" + '<a class="home" href="/" title="Hattulan Puu – etusivu" aria-label="Hattulan Puu – etusivu">' + HOG_SVG + "</a>" +
    '<div class="ttl"><div class="name">Hattibotti<span class="iq">' + esc(BOT_IQ) + "</span></div>" +
    '<div class="note">' + esc(BOT_IQ_NOTE) + "</div>" +
    '<div class="sub"><span class="dot"></span><span class="st">Hattulan Puun avustaja</span></div></div>' +
    '<button class="close clr" type="button" aria-label="Tyhjennä keskustelu" title="Tyhjennä keskustelu">' + ICON_TRASH + "</button>" +
    '<button class="close cls" type="button" aria-label="Sulje chat" title="Sulje">' + ICON_CLOSE + "</button>" +
    "</header>" +
    '<div class="confirm" hidden><span>Tyhjennetäänkö keskustelu? Viestit ja kuvat poistetaan.</span>' +
    '<button type="button" class="cbtn cancel">Peruuta</button><button type="button" class="cbtn danger">Tyhjennä</button></div>' +
    '<div class="notice" hidden></div>' +
    '<div class="msgs" aria-live="polite"></div>' +
    '<div class="contacts"></div>' +
    "<footer>" +
    '<div class="pv" hidden aria-live="polite"></div>' +
    '<div class="tools">' +
    '<button type="button" class="tool help">' + ICON_PERSON + "<span>Pyydä apua myyjältä</span></button>" +
    '<button type="button" class="tool call">' + ICON_PHONE + "<span>Soita myyjälle</span></button>" +
    "</div>" +
    '<div class="row">' +
    '<button class="ib att" type="button" aria-label="Liitä kuvia tai PDF (enintään 3)" title="Liitä kuvia tai PDF (enintään 3)">' + ICON_CLIP + "</button>" +
    '<label class="sr" for="hb-ta">Viesti</label>' +
    '<textarea id="hb-ta" rows="1" placeholder="Kirjoita viesti…" maxlength="2000"></textarea>' +
    '<button class="ib send" type="button" aria-label="Lähetä" disabled>' + ICON_SEND + "</button>" +
    "</div>" +
    '<input class="file" type="file" accept="image/*,application/pdf,.pdf" multiple hidden>' +
    '<p class="fine">Hattibotti on tekoäly ja voi erehtyä. Keskustelut tallennetaan asiakaspalvelua varten. <a href="' +
    escAttr(PRIVACY_URL) + '" target="_blank" rel="noopener">Tietosuoja</a></p>' +
    "</footer>" +
    "</section></div>";

  var $ = function (sel) {
    return root.querySelector(sel);
  };
  var wrap = $(".hb");
  var launch = $(".launch");
  var badge = $(".badge");
  var teaser = $(".teaser");
  var panel = $(".panel");
  var msgs = $(".msgs");
  var notice = $(".notice");
  var ta = $("textarea");
  var sendBtn = $(".send");
  var fileIn = $(".file");
  var pv = $(".pv");
  var attBtn = $(".att");
  var dot = $(".dot");
  var st = $(".st");
  var chipsEl = null;
  var contactsEl = $(".contacts");
  var confirmEl = $(".confirm");
  var helpBtn = $(".help");
  var clrBtn = $(".clr");
  var PLACEHOLDER = "Kirjoita viesti…";
  var PLACEHOLDER_IMG = "Paksuus x leveys, esim. 28 x 120 mm";
  var PLACEHOLDER_IMGS = "Mitä etsit? Esim. mitat";
  var PLACEHOLDER_PDF = "Mitä lasken? Esim. terassin laudat";
  var PLACEHOLDER_PDF_PRKL = "Esim. tee tästä suunnitelma";

  wrap.style.setProperty("--off", OFFSET + "px");

  function mount() {
    try {
      var f = getComputedStyle(document.body).fontFamily;
      if (f) wrap.style.setProperty("--hb-font", f);
    } catch (e) {}
    document.body.appendChild(host);
  }

  // ------------------------------------------------------------------
  // Tekstin muotoilu (turvallinen: kaikki escapoidaan ensin)
  // ------------------------------------------------------------------
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function escAttr(s) {
    return esc(s);
  }
  function link(url, text) {
    var internal = false;
    try {
      internal = new URL(url.replace(/&amp;/g, "&")).hostname.replace(/^www\./, "") === SHOP_HOST.replace(/^www\./, "");
    } catch (e) {}
    return '<a href="' + url + '"' + (internal ? "" : ' target="_blank" rel="noopener"') + ">" + text + "</a>";
  }
  function inline(t) {
    t = t.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    t = t.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function (m, txt, url) {
      return link(url, txt);
    });
    t = t.replace(/(^|[\s(])(https?:\/\/[^\s<)]+[^\s<).,!?:;])/g, function (m, pre, url) {
      return pre + link(url, url.replace(/^https?:\/\/(www\.)?/, ""));
    });
    return t;
  }
  function format(text) {
    var lines = esc(text || "").split(/\n/);
    var html = "";
    var inList = false;
    lines.forEach(function (line) {
      var m = line.match(/^\s*(?:[-•*]|\d+[.)])\s+(.*)$/);
      if (m) {
        if (!inList) {
          html += "<ul>";
          inList = true;
        }
        html += "<li>" + inline(m[1]) + "</li>";
      } else {
        if (inList) {
          html += "</ul>";
          inList = false;
        }
        if (line.trim()) html += "<p>" + inline(line) + "</p>";
      }
    });
    if (inList) html += "</ul>";
    return html;
  }

  // ------------------------------------------------------------------
  // Viestien piirto
  // ------------------------------------------------------------------
  function scrollDown() {
    msgs.scrollTop = msgs.scrollHeight;
  }

  function addMessage(m) {
    if (m.id && state.seen.has(m.id)) return null;
    if (m.id) state.seen.add(m.id);
    var el = document.createElement("div");
    var cls = m.role === "user" ? "user" : m.role === "staff" ? "staff" : "bot";
    el.className = "m " + cls;
    var html = "";
    if (m.role === "staff") html += '<span class="who">' + esc(m.staff_name || "Myyjä") + ", Hattulan Puu</span>";
    // Liitteet: uusi muoto attachments, vanha muoto file (PDF) tai image_url (kuva)
    var atts =
      m.attachments && m.attachments.length
        ? m.attachments
        : m.file
          ? [{ type: "pdf", name: m.file.name, pages: m.file.pages, url: m.file.preview || m.image_url }]
          : m.image_url
            ? [{ type: "image", url: m.image_url }]
            : [];
    var photos = atts.filter(function (a) {
      return a.type === "image" && a.url;
    });
    // Liitteet poistetaan 24 h jälkeen: kuvan tilalle merkintä
    var gone = atts.filter(function (a) {
      return a.type === "image" && !a.url;
    }).length;
    if (gone) {
      html += '<div class="gone">' + (gone === 1 ? "Kuva poistettu" : gone + " kuvaa poistettu") + " (liitteet säilytetään 24 tuntia)</div>";
    }
    if (photos.length === 1) html += '<img class="photo" alt="Kuva" src="' + escAttr(photos[0].url) + '">';
    else if (photos.length > 1) {
      html += '<div class="photos n' + Math.min(photos.length, 3) + '">';
      photos.forEach(function (a, i) {
        html += '<img alt="Kuva ' + (i + 1) + '" src="' + escAttr(a.url) + '">';
      });
      html += "</div>";
    }
    atts.forEach(function (a) {
      if (a.type !== "pdf") return;
      html +=
        '<div class="doc">' +
        (a.url ? '<img alt="" src="' + escAttr(a.url) + '">' : '<span class="dic">' + ICON_DOC + "</span>") +
        "<span>" + esc(a.name || "PDF") + (a.pages ? " · " + a.pages + " s." : "") + "</span></div>";
    });
    html += format(m.content || "");
    el.innerHTML = html;
    if (!m.content && !atts.length) return null;
    msgs.appendChild(el);
    if (m.products && m.products.length) msgs.appendChild(renderCards(m.products));
    if (m.plan && m.plan.url) msgs.appendChild(renderPlan(m.plan));
    if (m.freight && m.freight.hinta_sis_alv != null) msgs.appendChild(renderFreight(m.freight));
    var imgs = el.querySelectorAll("img");
    for (var i = 0; i < imgs.length; i++) imgs[i].addEventListener("load", scrollDown);
    scrollDown();
    return el;
  }

  function renderCards(products) {
    var box = document.createElement("div");
    box.className = "cards";
    products.forEach(function (p) {
      var a = document.createElement("a");
      a.className = "card";
      a.href = p.url;
      a.innerHTML =
        (p.image_url
          ? '<img alt="" loading="lazy" src="' + escAttr(p.image_url + (p.image_url.indexOf("?") > -1 ? "&" : "?") + "width=160") + '">'
          : '<span class="ph"></span>') +
        "<div>" +
        '<div class="t">' + esc(p.title) + "</div>" +
        (p.price_text ? '<div class="p">' + esc(p.price_text) + "</div>" : "") +
        (p.available === false ? '<div class="na">Ei juuri nyt saatavilla verkossa</div>' : "") +
        '<div class="go">Avaa tuotesivu</div>' +
        "</div>";
      var img = a.querySelector("img");
      if (img) {
        img.addEventListener("error", function () {
          if (img.dataset.fallback) return;
          img.dataset.fallback = "1";
          img.src = p.image_url;
        });
        img.addEventListener("load", scrollDown);
      }
      box.appendChild(a);
    });
    return box;
  }

  function onPrkl() {
    return location.pathname.replace(/\/+$/, "") === PRKL_PATH.replace(/\/+$/, "");
  }
  function onLevysahaus() {
    return location.pathname.replace(/\/+$/, "").toLowerCase() === LEVY_PATH.replace(/\/+$/, "").toLowerCase();
  }
  function setIntent(t) {
    try {
      sessionStorage.setItem(INTENT_KEY, JSON.stringify({ t: t, at: Date.now() }));
    } catch (e) {}
  }
  function takeIntent() {
    try {
      var raw = sessionStorage.getItem(INTENT_KEY);
      if (!raw) return null;
      sessionStorage.removeItem(INTENT_KEY);
      var it = JSON.parse(raw);
      return it && it.t && Date.now() - it.at < 180000 ? it : null;
    } catch (e) {
      return null;
    }
  }
  // Suunnitelmalinkki samaan osoitteeseen kuin nykyinen sivu (www / ilman), jotta chat aukeaa uudelleen
  function planHref(url) {
    try {
      var u = new URL(url, location.href);
      if (u.protocol !== "https:" && u.protocol !== "http:") return "#";
      var shop = /(^|\.)hattulanpuu\.fi$/;
      if (shop.test(location.hostname) && shop.test(u.hostname)) {
        u.protocol = location.protocol;
        u.host = location.host;
      }
      return u.href;
    } catch (e) {
      return "#";
    }
  }
  function renderPlan(plan) {
    var box = document.createElement("div");
    box.className = "plan";
    box.innerHTML =
      '<div class="pt">' + ICON_PLAN + "<span>" + esc(plan.title || "Suunnitelma PRKL-laskuriin") + "</span></div>" +
      (plan.summary ? '<div class="ps">' + esc(plan.summary) + "</div>" : "") +
      '<a class="pbtn" href="' + escAttr(planHref(plan.url)) + '">Avaa PRKL-laskurissa</a>' +
      (onPrkl() ? '<div class="pn">Avaaminen korvaa laskurissa nyt olevan suunnitelman. Tallenna se tarvittaessa ensin (TALLENNA → KOPIOI LINKKI).</div>' : "");
    box.querySelector(".pbtn").addEventListener("click", function () {
      setIntent("plan");
    });
    return box;
  }

  function addError(text) {
    var el = document.createElement("div");
    el.className = "err";
    el.textContent = text;
    msgs.appendChild(el);
    scrollDown();
  }

  function addMeta(text, left) {
    var el = document.createElement("div");
    el.className = "meta" + (left ? " left" : "");
    el.textContent = text;
    msgs.appendChild(el);
    scrollDown();
    return el;
  }

  // Viestitahdin hidastus (yli 30 viestiä vuorokaudessa → 1 viesti / 5 min): lähetysnappi odottaa
  var slowTimer = null;
  function clockText(t) {
    var d = new Date(t);
    var sameDay = new Date().toDateString() === d.toDateString();
    return (sameDay ? "" : d.getDate() + "." + (d.getMonth() + 1) + ". ") + "klo " + d.getHours() + "." + ("0" + d.getMinutes()).slice(-2);
  }
  function setSlow(iso) {
    var t = typeof iso === "number" ? iso : Date.parse(iso);
    if (!t || t <= Date.now()) return false;
    state.slowUntil = t;
    try {
      localStorage.setItem(SLOW_KEY, String(t));
    } catch (e) {}
    clearTimeout(slowTimer);
    slowTimer = setTimeout(function () {
      state.slowUntil = 0;
      updateSend();
    }, t - Date.now() + 300);
    updateSend();
    return true;
  }
  function slowActive() {
    return state.slowUntil > Date.now();
  }

  function showTyping() {
    var el = document.createElement("div");
    el.className = "typing";
    el.setAttribute("aria-label", "Hattibotti kirjoittaa");
    el.innerHTML = "<i></i><i></i><i></i>";
    msgs.appendChild(el);
    scrollDown();
    return el;
  }

  function renderChips(list) {
    hideChips();
    chipsEl = document.createElement("div");
    chipsEl.className = "chips";
    list.forEach(function (c) {
      var b;
      if (c.href) {
        // Linkkivalinta (esim. tarjouspyyntölomake)
        b = document.createElement("a");
        b.href = c.href;
        b.className = "chip";
        b.textContent = c.label;
        chipsEl.appendChild(b);
        return;
      }
      b = document.createElement("button");
      b.type = "button";
      b.className = "chip";
      b.textContent = c.label;
      b.addEventListener("click", function () {
        chipAction(c);
      });
      chipsEl.appendChild(b);
    });
    msgs.appendChild(chipsEl);
    scrollDown();
  }

  function chipAction(c) {
    if (c.image || c.file) return pickFiles();
    if (c.prkl) {
      var kind = c.prkl === true ? "prkl" : c.prkl;
      if (onPrkl()) return showPrklWelcome(kind);
      setIntent(kind);
      location.href = PRKL_PATH;
      return;
    }
    if (c.levy) {
      if (onLevysahaus()) return showLevyWelcome();
      setIntent("levy");
      location.href = LEVY_PATH;
      return;
    }
    if (c.freight) return showFreightForm();
    if (c.trailer) return showTrailerInfo();
    if (c.cancel) return showCancelForm();
    if (c.trailerForm) return showTrailerForm();
    send(c.text);
  }

  // Peräkärryn vuokra, vaihe 1: hinnat ja tarjouspyyntö; asiakas valitsee, haluaako vuokrata
  function trailerInfo() {
    var t = (state.hello && state.hello.trailer) || {};
    var v = function (k) {
      return t[k] != null ? t[k] : TRAILER_DEFAULTS[k];
    };
    return {
      url: v("tarjous_url"),
      text:
        "**Peräkärryn vuokra**\n" +
        "- Kärry: **" + v("hinta") + " €** – " + v("aika") + "\n" +
        "- Kuormaliinat: **" + v("liinat") + " €**\n\n" +
        "Vuokrakärry on tarkoitettu vain Hattulan Puun tuotteiden kuljettamiseen.\n\n" +
        "Tuotteet voi tilata jo ennakkoon **valmiiksi lastattuna** vuokraperäkärryyn [tarjouspyynnöllä](" + v("tarjous_url") + "), niin kärry odottaa sinua valmiina.\n\n" +
        "Haluatko vuokrata kärryn?",
    };
  }
  function showTrailerInfo() {
    hideChips();
    var info = trailerInfo();
    addMessage({ role: "assistant", content: info.text });
    renderChips([
      { label: "Vuokraa peräkärry", trailerForm: true },
      { label: "Tee tarjouspyyntö", href: info.url },
    ]);
  }

  // Päivämäärät muodossa "2026-10-21" (Suomen aika)
  function isoDay(d) {
    return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
  }
  function addDaysIso(iso, n) {
    var p = iso.split("-");
    return isoDay(new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]) + n));
  }
  function dayText(iso) {
    var p = iso.split("-");
    var d = new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]));
    return WEEKDAYS_ESS[d.getDay()] + " " + Number(p[2]) + "." + Number(p[1]) + ".";
  }
  function hm(s) {
    var p = String(s).split(":");
    return Number(p[0]) + "." + p[1];
  }

  // Peräkärryn vuokra, vaihe 2: puhelinnumero, päivä ja kellonaika → palvelin välittää varaustoiveen myyjille
  function showTrailerForm() {
    hideChips();
    addMessage({ role: "assistant", content: TRAILER_FORM_INTRO });
    var t = (state.hello && state.hello.trailer) || {};
    var days = t.days || null; // { "2026-10-21": ["08:00","17:00"] | null }
    var today = t.today || isoDay(new Date());
    var lastDay = days ? Object.keys(days).sort().slice(-1)[0] : addDaysIso(today, 59);
    var hoursOf = function (iso) {
      return days && Object.prototype.hasOwnProperty.call(days, iso) ? days[iso] : undefined;
    };
    // Oletuspäivä: tänään, jos ehtii vielä hakea (vähintään tunti ennen sulkemista), muuten seuraava aukiolopäivä
    var now = new Date();
    var nowMin = now.getHours() * 60 + now.getMinutes();
    var toMin = function (s) {
      var p = String(s).split(":");
      return Number(p[0]) * 60 + Number(p[1]);
    };
    var defDay = "";
    if (days) {
      for (var i = 0; i < 14; i++) {
        var iso = addDaysIso(today, i);
        var h = hoursOf(iso);
        if (h && !(i === 0 && nowMin > toMin(h[1]) - 60)) {
          defDay = iso;
          break;
        }
      }
    }
    var f = document.createElement("form");
    f.className = "ff";
    f.setAttribute("novalidate", "");
    f.innerHTML =
      '<label class="w"><span class="lt">Puhelinnumero</span><input type="tel" name="tel" inputmode="tel" maxlength="20" autocomplete="tel" placeholder="esim. 040 123 4567"></label>' +
      '<label><span class="lt">Päivä</span><input type="date" name="day" min="' + today + '" max="' + lastDay + '" value="' + defDay + '"></label>' +
      '<label><span class="lt">Kellonaika</span><input type="time" name="time" min="08:00" max="17:00"></label>' +
      '<small class="ch">Nouto aukioloaikoina: arkisin 8–17, lauantaisin 9–13.</small>' +
      '<div class="fe" role="alert"></div>' +
      '<button type="submit" class="fb">Lähetä varaustoive</button>';
    var err = f.querySelector(".fe");
    var hint = f.querySelector(".ch");
    var syncDay = function () {
      var iso = f.elements.day.value;
      var h = iso ? hoursOf(iso) : undefined;
      if (!iso || h === undefined) {
        hint.textContent = "Nouto aukioloaikoina: arkisin 8–17, lauantaisin 9–13.";
        return;
      }
      if (!h) {
        hint.textContent = dayText(iso).charAt(0).toUpperCase() + dayText(iso).slice(1) + " olemme suljettuina.";
        return;
      }
      f.elements.time.min = h[0];
      f.elements.time.max = h[1];
      hint.textContent = dayText(iso).charAt(0).toUpperCase() + dayText(iso).slice(1) + " auki klo " + hm(h[0]) + "–" + hm(h[1]) + ".";
    };
    f.elements.day.addEventListener("change", syncDay);
    f.elements.day.addEventListener("input", syncDay);
    syncDay();
    // Vanha virheilmoitus pois, kun asiakas korjaa kenttiä
    f.addEventListener("input", function () {
      err.textContent = "";
    });
    var setDisabled = function (on) {
      f.classList.toggle("done", on);
      var els = f.querySelectorAll("input,button");
      for (var i = 0; i < els.length; i++) els[i].disabled = on;
    };
    var fail = function (msg, field) {
      err.textContent = msg;
      if (field) f.elements[field].focus();
    };
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var tel = String(f.elements.tel.value).trim().replace(/\s+/g, " ");
      var day = String(f.elements.day.value);
      var time = String(f.elements.time.value).slice(0, 5);
      if (!/^\+?\d{6,15}$/.test(tel.replace(/[\s().-]/g, ""))) return fail("Kirjoita puhelinnumero, esim. 040 123 4567.", "tel");
      if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return fail("Valitse päivä, jolloin haluat hakea kärryn.", "day");
      if (day < today || day > lastDay) return fail("Valitse päivä tästä päivästä " + (days ? Object.keys(days).length : 60) + " päivän sisältä.", "day");
      var h = hoursOf(day);
      if (h === null) return fail(dayText(day).charAt(0).toUpperCase() + dayText(day).slice(1) + " olemme suljettuina. Valitse toinen päivä.", "day");
      if (!/^\d{2}:\d{2}$/.test(time)) return fail("Valitse kellonaika, jolloin haluat hakea kärryn.", "time");
      if (h && (toMin(time) < toMin(h[0]) || toMin(time) >= toMin(h[1]))) {
        return fail("Kärryn voi hakea aukioloaikoina: " + dayText(day) + " klo " + hm(h[0]) + "–" + hm(h[1]) + ".", "time");
      }
      err.textContent = "";
      setDisabled(true);
      send(
        "Haluan vuokrata peräkärryn " + dayText(day) + " klo " + hm(time) + ". Puhelinnumeroni on " + tel + ".",
        { trailer: { phone: tel, date: day, time: time } },
        function (e2) {
          // Palvelin hylkäsi (esim. suljettu päivä tai mennyt kellonaika): lomake takaisin käyttöön
          setDisabled(false);
          fail(e2 && e2.message && e2.message !== "Failed to fetch" ? e2.message : "Varaustoivetta ei voitu lähettää. Tarkista yhteys ja yritä uudelleen.");
        },
      );
    });
    msgs.appendChild(f);
    scrollDown();
    setTimeout(function () {
      try {
        f.elements.tel.focus();
      } catch (e) {}
    }, 50);
  }

  // Peru tilaus: tilausnumero ja puhelinnumero → palvelin lähettää peruutuspyynnön myyjille (Telegram)
  function showCancelForm() {
    hideChips();
    addMessage({ role: "assistant", content: CANCEL_INTRO });
    var f = document.createElement("form");
    f.className = "ff";
    f.setAttribute("novalidate", "");
    f.innerHTML =
      '<label><span class="lt">Tilausnumero</span><input type="text" name="order" maxlength="30" autocomplete="off" placeholder="esim. #12345"></label>' +
      '<label><span class="lt">Puhelinnumero</span><input type="tel" name="tel" inputmode="tel" maxlength="20" autocomplete="tel" placeholder="esim. 040 123 4567"></label>' +
      '<div class="fe" role="alert"></div>' +
      '<button type="submit" class="fb">Lähetä peruutuspyyntö</button>';
    var err = f.querySelector(".fe");
    var setDisabled = function (on) {
      f.classList.toggle("done", on);
      var els = f.querySelectorAll("input,button");
      for (var i = 0; i < els.length; i++) els[i].disabled = on;
    };
    var fail = function (msg, field) {
      err.textContent = msg;
      if (field) f.elements[field].focus();
    };
    f.addEventListener("input", function () {
      err.textContent = "";
    });
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var order = String(f.elements.order.value).trim().replace(/\s+/g, " ");
      var tel = String(f.elements.tel.value).trim().replace(/\s+/g, " ");
      if (!/^#?\s?[A-Za-z0-9][A-Za-z0-9 /-]{1,24}$/.test(order) || order.replace(/\D/g, "").length < 3) {
        return fail("Kirjoita tilausnumero, esim. #12345. Numero löytyy tilausvahvistuksesta.", "order");
      }
      if (!/^\+?\d{6,15}$/.test(tel.replace(/[\s().-]/g, ""))) return fail("Kirjoita puhelinnumero, esim. 040 123 4567.", "tel");
      err.textContent = "";
      setDisabled(true);
      send("Haluan perua tilauksen " + order + ". Puhelinnumeroni on " + tel + ".", { cancel: { order: order, phone: tel } }, function (e2) {
        setDisabled(false);
        fail(e2 && e2.message && e2.message !== "Failed to fetch" ? e2.message : "Pyyntöä ei voitu lähettää. Tarkista yhteys ja yritä uudelleen.");
      });
    });
    msgs.appendChild(f);
    scrollDown();
    setTimeout(function () {
      try {
        f.elements.order.focus();
      } catch (e) {}
    }, 50);
  }

  // Toimituksen hinta: postinumero, paino ja pisin kappale → viesti botille, joka laskee rahdin
  function numIn(v) {
    var n = parseFloat(String(v).replace(/\s/g, "").replace(",", "."));
    return isFinite(n) ? n : NaN;
  }
  function showFreightForm() {
    hideChips();
    addMessage({ role: "assistant", content: FREIGHT_INTRO });
    var f = document.createElement("form");
    f.className = "ff";
    f.setAttribute("novalidate", "");
    f.innerHTML =
      '<label><span class="lt">Postinumero</span><input type="text" name="pno" inputmode="numeric" maxlength="5" autocomplete="postal-code" placeholder="esim. 06100"></label>' +
      '<label><span class="lt">Paino (kg) <i>valinnainen</i></span><input type="text" name="kg" inputmode="decimal" maxlength="7" placeholder="esim. 500"></label>' +
      '<label class="w"><span class="lt">Pisin kappale (m) <i>valinnainen</i></span><input type="text" name="len" inputmode="decimal" maxlength="5" placeholder="esim. 4,8"></label>' +
      '<label class="chk"><input type="checkbox" name="biz"> Tilaan yritykselle</label>' +
      '<label class="chk"><input type="checkbox" name="crane"> Tarvitsen nosturipurun</label>' +
      '<small class="ch" hidden>Alle 2,4 m kappaleet puretaan aina ilman nosturia.</small>' +
      '<div class="fe" role="alert"></div>' +
      '<button type="submit" class="fb">Laske toimituksen hinta</button>';
    var err = f.querySelector(".fe");
    // Alle 2,4 m kappaleet eivät koskaan tarvitse nosturipurkua
    var craneHint = f.querySelector(".ch");
    var syncCrane = function () {
      var l = numIn(f.elements.len.value);
      var short = String(f.elements.len.value).trim() !== "" && l > 0 && l < 2.4;
      f.elements.crane.disabled = short;
      if (short) f.elements.crane.checked = false;
      craneHint.hidden = !short;
    };
    f.elements.len.addEventListener("input", syncCrane);
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var pno = String(f.elements.pno.value).replace(/\s/g, "");
      var kgRaw = String(f.elements.kg.value).trim();
      var lenRaw = String(f.elements.len.value).trim();
      var kg = kgRaw ? numIn(kgRaw) : null;
      var len = lenRaw ? numIn(lenRaw) : null;
      if (!/^\d{5}$/.test(pno)) {
        err.textContent = "Kirjoita postinumero viidellä numerolla, esim. 06100.";
        f.elements.pno.focus();
        return;
      }
      if (kg !== null && !(kg > 0 && kg <= 50000)) {
        err.textContent = "Tarkista paino (kilogrammoina), tai jätä se tyhjäksi.";
        f.elements.kg.focus();
        return;
      }
      if (len !== null && !(len > 0 && len <= 20)) {
        err.textContent = "Tarkista pisimmän kappaleen pituus metreinä, esim. 4,8.";
        f.elements.len.focus();
        return;
      }
      err.textContent = "";
      var fmt = function (n) {
        return String(Math.round(n * 100) / 100).replace(".", ",");
      };
      var text =
        "Laske toimituksen hinta: postinumero " + pno +
        (kg !== null ? ", paino " + fmt(kg) + " kg" : ", paino ei tiedossa") +
        (len !== null ? ", pisin kappale " + fmt(len) + " m" : "") +
        (f.elements.biz.checked ? ", yritysasiakas" : "") +
        (f.elements.crane.checked && !f.elements.crane.disabled ? ", tarvitsen nosturipurun" : "") + ".";
      f.classList.add("done");
      var els = f.querySelectorAll("input,button");
      for (var i = 0; i < els.length; i++) els[i].disabled = true;
      send(text);
    });
    msgs.appendChild(f);
    scrollDown();
    setTimeout(function () {
      try {
        f.elements.pno.focus();
      } catch (e) {}
    }, 50);
  }

  function renderFreight(fr) {
    var box = document.createElement("div");
    box.className = "frt";
    var price = Number(fr.hinta_sis_alv);
    box.innerHTML =
      '<div class="ft">' + ICON_TRUCK + "<span>Toimituksen hinta (alustava)</span></div>" +
      '<div class="fp">' + esc(price.toLocaleString("fi-FI", { maximumFractionDigits: 2 })) + " €<small>sis. alv</small></div>" +
      "<dl><dt>Kuljetus</dt><dd>" + esc(fr.kuljetustapa || "") + "</dd>" +
      "<dt>Alue</dt><dd>" + esc(fr.toimitusalue || "") + "</dd>" +
      "<dt>Paino</dt><dd>" + esc(String(fr.paino_kg || "")) + " kg" + (fr.paino_oletus ? " (oletus, ei tiedossa)" : "") + "</dd>" +
      (fr.nosturipurku === true ? "<dt>Purku</dt><dd>Nosturipurku sisältyy</dd>" : fr.nosturipurku === false ? "<dt>Purku</dt><dd>Ilman nosturipurkua</dd>" : "") +
      "</dl>" +
      '<div class="fn">Hinta on alustava. Lopullinen rahti vahvistetaan laskulla.</div>';
    return box;
  }

  // Valmis ohje levysahauslaskuriin (paikallinen viesti, ei tallennu eikä kuluta tokeneita)
  function showLevyWelcome() {
    hideChips();
    addMessage({ role: "assistant", content: LEVY_WELCOME });
    renderChips(LEVY_CHIPS);
  }

  function showPrklWelcome(kind) {
    hideChips();
    if (kind === "plan") {
      addMessage({ role: "assistant", content: PLAN_OPENED });
      return;
    }
    if (kind === "terassi") {
      addMessage({ role: "assistant", content: TERRACE_WELCOME });
      renderChips(TERRACE_CHIPS);
      return;
    }
    addMessage({ role: "assistant", content: PRKL_WELCOME });
    renderChips(PRKL_CHIPS);
  }

  function renderWelcome() {
    msgs.innerHTML = "";
    chipsEl = null;
    addMessage({ role: "assistant", content: GREETING });
    if (!state.id) {
      renderChips(
        onLevysahaus()
          ? [LEVY_CHIP].concat(
              CHIPS.filter(function (c) {
                return !c.levy;
              }),
            )
          : CHIPS,
      );
    }
  }

  function hideChips() {
    if (chipsEl) {
      chipsEl.remove();
      chipsEl = null;
    }
  }

  function setStatus(s) {
    if (!s) return;
    state.status = s;
    save();
    helpBtn.disabled = s !== "bot" || state.busy;
    helpBtn.querySelector("span").textContent = s === "bot" ? "Pyydä apua myyjältä" : "Myyjältä pyydetty apua";
    if (s === "handoff") {
      notice.className = "notice";
      notice.textContent =
        "Apupyyntö on välitetty myyjälle. Vastaus tulee tähän keskusteluun" +
        (state.hello && !state.hello.open ? " (" + state.hello.status_text.toLowerCase() + ")." : ".");
      notice.hidden = false;
    } else if (s === "human") {
      notice.className = "notice human";
      notice.textContent = "Keskustelet nyt Hattulan Puun myyjän kanssa.";
      notice.hidden = false;
    } else {
      notice.hidden = true;
    }
  }

  function setUnread(n) {
    state.unread = n;
    badge.textContent = n > 9 ? "9+" : String(n);
    badge.hidden = n === 0;
    launch.setAttribute("aria-label", n ? "Avaa Hattibotti-chat, " + n + " uutta viestiä" : "Avaa Hattibotti-chat");
  }

  // ------------------------------------------------------------------
  // Palvelin
  // ------------------------------------------------------------------
  function api(action, payload) {
    return fetch(ENDPOINT, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(Object.assign({ action: action }, payload || {})),
    }).then(function (res) {
      return res
        .json()
        .catch(function () {
          return null;
        })
        .then(function (data) {
          if (!res.ok) {
            var err = new Error((data && data.message) || "Yhteysvirhe");
            err.status = res.status;
            err.data = data || {};
            throw err;
          }
          return data;
        });
    });
  }

  function hello(cb) {
    if (state.hello) return;
    api("hello")
      .then(function (h) {
        state.hello = h;
        st.textContent = h.status_text;
        dot.className = "dot" + (h.open ? " on" : "");
        setStatus(state.status);
        if (cb) cb();
      })
      .catch(function () {});
  }

  function restore() {
    if (state.restored || !state.id) return Promise.resolve();
    return api("poll", { conversation_id: state.id, token: state.token, after: 0 })
      .then(function (r) {
        state.restored = true;
        renderWelcome();
        applyPoll(r, false);
      })
      .catch(function (e) {
        if (e.status === 403) {
          forget();
          renderWelcome();
        }
      });
  }

  function applyPoll(r, countUnread) {
    if (!r) return;
    var fresh = 0;
    (r.messages || []).forEach(function (m) {
      state.lastId = Math.max(state.lastId, m.id);
      if (state.seen.has(m.id)) return;
      if (state.restored) {
        if (addMessage(m) && m.role !== "user") fresh++;
      } else if (m.role !== "user") {
        // Paneelia ei ole vielä avattu: lasketaan vain lukemattomat,
        // viestit piirretään kun keskustelu avataan
        fresh++;
      }
    });
    if (r.status) setStatus(r.status);
    if (countUnread && fresh && !state.open) setUnread(state.unread + fresh);
  }

  var pollTimer = null;
  function schedulePoll() {
    clearTimeout(pollTimer);
    if (!state.id) return;
    var delay = state.open ? (state.status === "bot" ? 30000 : 4000) : state.status === "bot" ? 0 : 20000;
    if (!delay) return;
    if (document.hidden) delay = Math.max(delay, 60000);
    pollTimer = setTimeout(doPoll, delay);
  }
  function doPoll() {
    if (!state.id || state.busy) return schedulePoll();
    api("poll", { conversation_id: state.id, token: state.token, after: state.lastId })
      .then(function (r) {
        applyPoll(r, true);
      })
      .catch(function (e) {
        if (e.status === 403) forget();
      })
      .then(schedulePoll);
  }

  // ------------------------------------------------------------------
  // Kuvat
  // ------------------------------------------------------------------
  function prepareImage(file) {
    return new Promise(function (resolve, reject) {
      if (!file || !/^image\//.test(file.type || "image/")) return reject(new Error("type"));
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var w = img.naturalWidth,
          h = img.naturalHeight;
        var s = Math.min(1, MAX_IMAGE_SIDE / Math.max(w, h));
        var c = document.createElement("canvas");
        c.width = Math.round(w * s);
        c.height = Math.round(h * s);
        var ctx = c.getContext("2d");
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, c.width, c.height);
        ctx.drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        var dataUrl = c.toDataURL("image/jpeg", 0.85);
        resolve({ data: dataUrl.split(",")[1], media_type: "image/jpeg", preview: dataUrl });
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        reject(new Error("decode"));
      };
      img.src = url;
    });
  }

  // ------------------------------------------------------------------
  // PDF: sivut kuviksi ja teksti talteen selaimessa (pdf.js ladataan tarvittaessa)
  // ------------------------------------------------------------------
  var pdfjsPromise = null;
  function loadPdfJs() {
    if (window.pdfjsLib && window.pdfjsLib.getDocument) return Promise.resolve(window.pdfjsLib);
    if (pdfjsPromise) return pdfjsPromise;
    pdfjsPromise = new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = PDFJS_BASE + "pdf.min.js";
      s.async = true;
      s.onload = function () {
        var lib = window.pdfjsLib;
        if (!lib || !lib.getDocument) return reject(new Error("pdfjs"));
        try {
          lib.GlobalWorkerOptions.workerSrc = PDFJS_BASE + "pdf.worker.min.js";
        } catch (e) {}
        resolve(lib);
      };
      s.onerror = function () {
        reject(new Error("pdfjs"));
      };
      document.head.appendChild(s);
    }).catch(function (e) {
      pdfjsPromise = null;
      throw e;
    });
    return pdfjsPromise;
  }

  function readFile(file) {
    return new Promise(function (resolve, reject) {
      var r = new FileReader();
      r.onload = function () {
        resolve(new Uint8Array(r.result));
      };
      r.onerror = function () {
        reject(new Error("read"));
      };
      r.readAsArrayBuffer(file);
    });
  }

  function bytesToB64(bytes) {
    var bin = "";
    for (var i = 0; i < bytes.length; i += 0x8000) bin += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
    return btoa(bin);
  }

  function renderPdfImage(page, scale, w, h, x0, y0) {
    var vp = page.getViewport({ scale: scale, offsetX: -x0, offsetY: -y0 });
    var c = document.createElement("canvas");
    c.width = w;
    c.height = h;
    var ctx = c.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, w, h);
    // intent "print": piirto ei odota requestAnimationFramea, joten se valmistuu myös taustavälilehdellä
    return page.render({ canvasContext: ctx, viewport: vp, intent: "print" }).promise.then(function () {
      var url = c.toDataURL("image/jpeg", 0.82);
      c.width = 0;
      c.height = 0;
      return url;
    });
  }

  // Suurennosruudukko: ruudut enintään PDF_TILE px (Claude pienentää isommat kuvat),
  // sivu niin suurena, että piirustuksen 2,5 mm tekstit ovat n. 12 px korkeita.
  var ROW_NAMES = { 1: [""], 2: ["yläosa", "alaosa"], 3: ["yläosa", "keskiosa", "alaosa"] };
  var COL_NAMES = { 1: [""], 2: ["vasen", "oikea"], 3: ["vasen", "keski", "oikea"] };
  function tileGrid(w, h) {
    var s = PDF_TILE_PX_PER_PT;
    var cols, rows;
    for (;;) {
      cols = Math.ceil((w * s) / (PDF_TILE * 0.94));
      rows = Math.ceil((h * s) / (PDF_TILE * 0.94));
      if ((cols <= 3 && rows <= 3 && cols * rows <= PDF_MAX_TILES) || s < 0.6) break;
      s *= 0.92;
    }
    return { s: s, cols: Math.min(cols, 3), rows: Math.min(rows, 3) };
  }

  function renderPageImages(page, pn, out) {
    var base = page.getViewport({ scale: 1 });
    var long = Math.max(base.width, base.height);
    var sc = Math.min(PDF_SIDE / long, 6);
    return renderPdfImage(page, sc, Math.round(base.width * sc), Math.round(base.height * sc), 0, 0).then(function (url) {
      out.images.push({ data: url.split(",")[1], label: "Sivu " + pn });
      if (!out.preview) out.preview = url;
      // Iso sivu (A3 ja suuremmat, esim. A1-asemapiirros): suurennokset pienten lukujen lukemiseen
      if (pn !== 1 || long * PDF_TILE_PX_PER_PT <= PDF_TILE) return;
      var g = tileGrid(base.width, base.height);
      if (g.cols * g.rows < 2) return;
      var W2 = base.width * g.s;
      var H2 = base.height * g.s;
      var tw = Math.min(Math.ceil((W2 / g.cols) * 1.06), Math.ceil(W2));
      var th = Math.min(Math.ceil((H2 / g.rows) * 1.06), Math.ceil(H2));
      var chain = Promise.resolve();
      for (var r = 0; r < g.rows; r++) {
        for (var c = 0; c < g.cols; c++) {
          (function (r, c) {
            var x0 = g.cols > 1 ? Math.round((c * (W2 - tw)) / (g.cols - 1)) : 0;
            var y0 = g.rows > 1 ? Math.round((r * (H2 - th)) / (g.rows - 1)) : 0;
            var name = [ROW_NAMES[g.rows][r], COL_NAMES[g.cols][c]].filter(Boolean).join(" ");
            chain = chain.then(function () {
              return renderPdfImage(page, g.s, tw, th, x0, y0).then(function (u) {
                out.images.push({ data: u.split(",")[1], label: "Sivu " + pn + ", suurennos: " + name });
              });
            });
          })(r, c);
        }
      }
      return chain;
    });
  }

  function preparePdf(file) {
    if (file.size > PDF_MAX_BYTES) return Promise.reject(new Error("size"));
    var name = String(file.name || "liite.pdf").slice(0, 120);
    return readFile(file).then(function (bytes) {
      if (!(bytes[0] === 0x25 && bytes[1] === 0x50 && bytes[2] === 0x44 && bytes[3] === 0x46)) throw new Error("type");
      var out = {
        name: name,
        pages: 0,
        text: "",
        images: [],
        file: bytes.length <= PDF_SEND_MAX_BYTES ? bytesToB64(bytes) : null,
        fileSize: bytes.length,
        preview: null,
      };
      var texts = [];
      return loadPdfJs()
        .then(function (lib) {
          // isEvalSupported: false = turvallinen fonttien käsittely
          return lib.getDocument({ data: bytes.slice(0), isEvalSupported: false }).promise;
        })
        .then(function (doc) {
          out.pages = doc.numPages;
          var nImg = Math.min(doc.numPages, PDF_MAX_PAGES);
          var nTxt = Math.min(doc.numPages, PDF_TEXT_PAGES);
          var chain = Promise.resolve();
          for (var pn = 1; pn <= Math.max(nImg, nTxt); pn++) {
            (function (n) {
              chain = chain.then(function () {
                return doc.getPage(n).then(function (page) {
                  var steps = Promise.resolve();
                  if (n <= nTxt) {
                    steps = steps.then(function () {
                      return page
                        .getTextContent()
                        .then(function (tc) {
                          var t = tc.items
                            .map(function (it) {
                              return (it.str || "") + (it.hasEOL ? "\n" : " ");
                            })
                            .join("")
                            .replace(/[ \t]+/g, " ")
                            .trim();
                          if (t) texts.push("--- Sivu " + n + " ---\n" + t);
                        })
                        .catch(function () {});
                    });
                  }
                  if (n <= nImg) {
                    steps = steps.then(function () {
                      return renderPageImages(page, n, out);
                    });
                  }
                  return steps.then(function () {
                    page.cleanup();
                  });
                });
              });
            })(pn);
          }
          return chain.then(function () {
            out.text = texts.join("\n\n").slice(0, PDF_TEXT_MAX);
            doc.destroy();
            return out;
          });
        })
        .catch(function (e) {
          // pdf.js ei latautunut tai sivua ei saatu kuvaksi: lähetetään mitä saatiin
          // (palvelin antaa alkuperäisen PDF:n botille, jos sivukuvia ei ole)
          if (out.images.length || out.file) {
            out.text = texts.join("\n\n").slice(0, PDF_TEXT_MAX);
            return out;
          }
          throw e;
        });
    });
  }

  function isPdf(file) {
    return !!file && (file.type === "application/pdf" || /\.pdf$/i.test(file.name || ""));
  }

  // ------------------------------------------------------------------
  // Liitteet: enintään MAX_ATTACHMENTS kuvaa tai PDF:ää yhteen viestiin
  // ------------------------------------------------------------------
  var ICON_X_SMALL =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var LIMIT_TEXT = "Voit liittää yhteen viestiin enintään " + MAX_ATTACHMENTS + " kuvaa tai PDF-tiedostoa.";

  function freeSlots() {
    return MAX_ATTACHMENTS - state.atts.length;
  }

  function pickFiles() {
    if (freeSlots() <= 0) return addError(LIMIT_TEXT);
    fileIn.click();
  }

  // Tiedostovalinta, liittäminen tai raahaus: otetaan niin monta kuin mahtuu
  function attachFiles(list) {
    var files = Array.prototype.slice.call(list || []).filter(Boolean);
    if (!files.length) return;
    var free = freeSlots();
    if (files.length > free) {
      addError(free > 0 ? LIMIT_TEXT + " Liitin " + (free === 1 ? "ensimmäisen" : free + " ensimmäistä") + "." : LIMIT_TEXT);
    }
    files.slice(0, Math.max(0, free)).forEach(attach);
  }

  function attach(file) {
    if (!file || freeSlots() <= 0) return;
    var pdf = isPdf(file);
    var item = { kind: pdf ? "pdf" : "image", ready: false, name: String(file.name || (pdf ? "liite.pdf" : "kuva")).slice(0, 120) };
    state.atts.push(item);
    refreshAtts();
    var still = function () {
      return state.atts.indexOf(item) >= 0;
    };
    var job = pdf ? preparePdf(file) : prepareImage(file);
    job
      .then(function (res) {
        if (!still()) return;
        for (var k in res) item[k] = res[k];
        item.ready = true;
        refreshAtts();
        ta.focus();
      })
      .catch(function (e) {
        if (!still()) return;
        removeAtt(item);
        addError(
          !pdf
            ? "Tiedostoa " + item.name + " ei voitu lukea. Lähetä kuva (JPG tai PNG) tai PDF."
            : e && e.message === "size"
              ? "PDF " + item.name + " on liian suuri (enintään 20 Mt)."
              : e && e.message === "type"
                ? "Tiedosto " + item.name + " ei ole PDF."
                : "PDF-tiedostoa " + item.name + " ei voitu lukea. Kokeile toista tiedostoa tai lähetä kuva piirustuksesta.",
        );
      });
  }

  function removeAtt(item) {
    var i = state.atts.indexOf(item);
    if (i >= 0) state.atts.splice(i, 1);
    refreshAtts();
  }

  function clearAttachments() {
    state.atts = [];
    refreshAtts();
  }

  // Liitelista näkyviin, lähetysnapin ja kirjoituskentän vihjeen päivitys
  function refreshAtts() {
    var list = state.atts;
    state.preparing = list.some(function (a) {
      return !a.ready;
    });
    pv.innerHTML = "";
    pv.hidden = !list.length;
    list.forEach(function (a, i) {
      var el = document.createElement("div");
      el.className = "ai" + (a.kind === "pdf" ? " pdf" : "");
      var label = a.kind === "pdf" ? a.name + (a.pages ? " · " + a.pages + " s." : "") : "Kuva " + (i + 1);
      el.title = label;
      el.innerHTML =
        (!a.ready ? '<span class="spin"></span>' : a.preview ? '<img alt="">' : '<span class="dic">' + ICON_DOC + "</span>") +
        (a.kind === "pdf" ? '<span class="tag">PDF</span>' : "") +
        '<button type="button" class="rx" aria-label="Poista liite: ' + escAttr(label) + '">' + ICON_X_SMALL + "</button>";
      var img = el.querySelector("img");
      if (img) img.src = a.preview;
      el.querySelector(".rx").addEventListener("click", function () {
        removeAtt(a);
      });
      pv.appendChild(el);
    });
    if (list.length) {
      var t = document.createElement("span");
      t.className = "pvt";
      var pdfs = list.filter(function (a) {
        return a.kind === "pdf";
      });
      var free = freeSlots();
      var txt;
      if (state.preparing) txt = pdfs.some(function (a) { return !a.ready; }) ? "Luetaan PDF-tiedostoa…" : "Käsitellään kuvaa…";
      else if (list.length === 1) txt = list[0].kind === "pdf" ? "PDF: " + list[0].name + (list[0].pages ? " · " + list[0].pages + " s." : "") : "Kuva liitetty";
      else txt = list.length + " liitettä";
      if (!state.preparing) txt += free > 0 ? " · voit lisätä vielä " + free : " · enintään " + MAX_ATTACHMENTS;
      t.textContent = txt;
      pv.appendChild(t);
    }
    attBtn.disabled = freeSlots() <= 0;
    var hasPdf = list.some(function (a) {
      return a.kind === "pdf";
    });
    ta.placeholder = !list.length ? PLACEHOLDER : hasPdf ? (onPrkl() ? PLACEHOLDER_PDF_PRKL : PLACEHOLDER_PDF) : list.length > 1 ? PLACEHOLDER_IMGS : PLACEHOLDER_IMG;
    fileIn.value = "";
    updateSend();
  }

  // Lähetettävät liitteet. Useampi PDF jakaa kuvabudjetin: ensin sivukuvat, suurennokset vain jos kaikki mahtuvat.
  // Alkuperäiset PDF:t (myyjille) mukaan, kunnes yhteiskoko PDF_SEND_MAX_BYTES täyttyy.
  function pickPdfImages(list, share) {
    if (list.length <= share) return list;
    var isTile = function (im) {
      return /suurennos/.test(im.label);
    };
    var keep = list.filter(function (im) {
      return !isTile(im);
    }).slice(0, share);
    var tiles = list.filter(isTile);
    if (keep.length + tiles.length <= share) keep = keep.concat(tiles);
    return list.filter(function (im) {
      return keep.indexOf(im) >= 0;
    });
  }
  function attachmentPayload(list) {
    var nPdf = list.filter(function (a) {
      return a.kind === "pdf";
    }).length;
    var share = nPdf ? Math.min(PDF_IMAGES_PER_FILE, Math.floor(PDF_IMAGES_TOTAL / nPdf)) : 0;
    var fileBudget = PDF_SEND_MAX_BYTES;
    return list.map(function (a) {
      if (a.kind === "image") return { type: "image", data: a.data, media_type: a.media_type };
      var file = null;
      if (a.file && a.fileSize <= fileBudget) {
        file = a.file;
        fileBudget -= a.fileSize;
      }
      return { type: "pdf", name: a.name, pages: a.pages, text: a.text, images: pickPdfImages(a.images || [], share), file: file };
    });
  }

  // PRKL-laskurin nykyinen suunnitelma botille (vain PRKL-sivulla)
  function prklState() {
    if (!onPrkl() || typeof window.yardStateForSave !== "function") return null;
    try {
      var st = window.yardStateForSave(true);
      return st && JSON.stringify(st).length <= 80000 ? st : null;
    } catch (e) {
      return null;
    }
  }

  // ------------------------------------------------------------------
  // Lähetys
  // ------------------------------------------------------------------
  function updateSend() {
    var slow = slowActive();
    sendBtn.disabled = state.busy || state.preparing || slow || (!ta.value.trim() && !state.atts.length);
    sendBtn.title = slow ? "Voit lähettää seuraavan viestin " + clockText(state.slowUntil) : "";
    helpBtn.disabled = state.busy || state.status !== "bot";
    clrBtn.disabled = state.busy;
  }

  function autosize() {
    ta.style.height = "auto";
    ta.style.height = Math.min(ta.scrollHeight + 2, 130) + "px";
  }

  // extra: lisäkentät palvelimelle; onFail: lomake käsittelee virheen itse (viestikupla poistetaan)
  function send(textOverride, extra, onFail) {
    if (state.busy) return;
    if (state.preparing) return;
    var text = (typeof textOverride === "string" ? textOverride : ta.value).trim();
    // Pikavalinnat ja lomakkeet (textOverride) eivät vie liitteitä mukanaan
    var atts = typeof textOverride === "string" && extra ? [] : state.atts.slice();
    if (!text && !atts.length) return;
    // Hidastus päällä: viestiä ei lähetetä, teksti jää talteen
    if (slowActive()) {
      var wait = "Voit lähettää seuraavan viestin " + clockText(state.slowUntil) + ".";
      if (onFail) return onFail(new Error(wait));
      addError(wait);
      if (typeof textOverride === "string" && !ta.value) {
        ta.value = text;
        autosize();
      }
      return;
    }
    var hasPdf = atts.some(function (a) {
      return a.kind === "pdf";
    });

    state.busy = true;
    if (typeof textOverride !== "string") ta.value = "";
    autosize();
    if (atts.length) clearAttachments();
    hideChips();
    updateSend();

    var bubble = addMessage({
      role: "user",
      content: text,
      attachments: atts.map(function (a) {
        return a.kind === "image" ? { type: "image", url: a.preview } : { type: "pdf", name: a.name, pages: a.pages, url: a.preview };
      }),
    });
    var typing = state.status === "human" ? null : showTyping();
    var hintEl = null;
    var hintTimer =
      hasPdf && typing
        ? setTimeout(function () {
            hintEl = addMeta(atts.length > 1 ? "Luen tiedostoja – tämä voi kestää noin minuutin." : "Luen tiedostoa – tämä voi kestää noin minuutin.", true);
          }, 6000)
        : null;

    var payload = { text: text, page_url: location.href, page_title: document.title, client_id: clientId() };
    if (atts.length) payload.attachments = attachmentPayload(atts);
    var ps = prklState();
    if (ps) payload.prkl = ps;
    if (extra) Object.assign(payload, extra);

    var withConv = function () {
      return state.id ? Object.assign({ conversation_id: state.id, token: state.token }, payload) : payload;
    };

    api("send", withConv())
      .catch(function (e) {
        // Vanha keskustelu poistettu → aloitetaan uusi
        if (e.status === 403 && state.id) {
          forget();
          return api("send", payload);
        }
        throw e;
      })
      .then(function (r) {
        if (r.token) {
          state.id = r.conversation_id;
          state.token = r.token;
          state.restored = true;
        }
        if (r.user_message_id) state.seen.add(r.user_message_id);
        (r.replies || []).forEach(addMessage);
        if (r.status === "human" && !(r.replies || []).length) addMeta("Välitetty myyjälle");
        // Rajat: hidastettu viestitahti ja päivän jäljellä olevat liitteet
        var rate = r.rate || {};
        if (rate.slow && setSlow(rate.next_at)) {
          addMeta("Seuraavan viestin voit lähettää " + clockText(state.slowUntil) + " (yksi viesti / " + (rate.minutes || 5) + " min).", true);
        }
        if (atts.length && typeof rate.attachments_left === "number" && rate.attachments_left <= 3) {
          addMeta(
            rate.attachments_left > 0
              ? "Voit lähettää tänään vielä " + rate.attachments_left + " kuvaa tai PDF-tiedostoa."
              : "Päivän kuvat ja PDF-tiedostot on käytetty. Voit jatkaa keskustelua tekstillä.",
            true,
          );
        }
        setStatus(r.status);
        save();
      })
      .catch(function (e) {
        if (e && e.data && e.data.error === "slow" && e.data.retry_at) setSlow(e.data.retry_at);
        if (onFail) {
          if (bubble) bubble.remove();
          onFail(e);
          return;
        }
        if (bubble) bubble.classList.add("failed");
        addError(e && e.message && e.message !== "Failed to fetch" ? e.message : "Viestiä ei voitu lähettää. Tarkista yhteys ja yritä uudelleen.");
        // Liitteet takaisin, ettei niitä tarvitse valita ja lukea uudelleen
        if (atts.length && !state.atts.length) {
          state.atts = atts;
          refreshAtts();
        }
        if (!ta.value && text) {
          ta.value = text;
          autosize();
        }
      })
      .then(function () {
        if (typing) typing.remove();
        clearTimeout(hintTimer);
        if (hintEl) hintEl.remove();
        state.busy = false;
        updateSend();
        schedulePoll();
      });
  }

  // ------------------------------------------------------------------
  // Yhteystiedot
  // ------------------------------------------------------------------
  function telHref(n) {
    return "tel:" + String(n).replace(/[^\d+]/g, "");
  }
  function renderContacts() {
    var h = state.hello || {};
    var main = h.main_phone || "019 661 5500";
    var html =
      '<button type="button" class="back">' + ICON_BACK + "Takaisin chattiin</button>" +
      '<p class="ct">' + esc(h.hours_text || "Arkisin 8–17, lauantaisin 9–13") + "</p>" +
      '<a class="pc" href="' + telHref(main) + '"><span class="pi">' + ICON_PHONE + "</span>" +
      "<span><b>Hattulan Puu, vaihde</b><small>Yleiset asiat ja tilaukset</small></span>" +
      '<span class="num">' + ICON_PHONE + esc(main) + "</span></a>";
    (h.contacts || []).forEach(function (c) {
      html +=
        '<a class="pc" href="' + telHref(c.phone) + '">' +
        (c.image ? '<img alt="" loading="lazy" src="' + escAttr(c.image) + '">' : '<span class="pi">' + ICON_PERSON + "</span>") +
        "<span><b>" + esc(c.name) + "</b><small>" + esc(c.role || "") + "</small></span>" +
        '<span class="num">' + ICON_PHONE + esc(c.phone) + "</span></a>";
    });
    if (h.email) html += '<p class="mail">Sähköposti: <a href="mailto:' + escAttr(h.email) + '">' + esc(h.email) + "</a></p>";
    contactsEl.innerHTML = html;
    contactsEl.querySelector(".back").addEventListener("click", hideContacts);
  }
  function showContacts() {
    hideConfirm();
    renderContacts();
    panel.classList.add("cv");
    contactsEl.scrollTop = 0;
    if (!state.hello) hello(renderContacts);
  }
  function hideContacts() {
    panel.classList.remove("cv");
    scrollDown();
  }

  // ------------------------------------------------------------------
  // Keskustelun tyhjennys
  // ------------------------------------------------------------------
  function showConfirm() {
    if (state.busy) return;
    hideContacts();
    confirmEl.hidden = false;
    confirmEl.querySelector(".cancel").focus();
  }
  function hideConfirm() {
    confirmEl.hidden = true;
  }
  function clearConversation() {
    if (state.busy) return;
    hideConfirm();
    var id = state.id;
    var token = state.token;
    clearTimeout(pollTimer);
    forget();
    state.restored = true;
    setUnread(0);
    clearAttachments();
    ta.value = "";
    autosize();
    renderWelcome();
    setStatus("bot");
    updateSend();
    if (id) api("clear", { conversation_id: id, token: token }).catch(function () {});
  }

  // ------------------------------------------------------------------
  // Avaus ja sulkeminen
  // ------------------------------------------------------------------
  var mobile = window.matchMedia("(max-width: 640px)");
  var touch = window.matchMedia("(pointer: coarse)");
  var prevOverflow = "";

  function openPanel() {
    state.open = true;
    panel.hidden = false;
    teaser.hidden = true;
    launch.setAttribute("aria-expanded", "true");
    setUnread(0);
    try {
      sessionStorage.setItem("hattibotti:teased", "1");
    } catch (e) {}
    if (mobile.matches) {
      prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = "hidden";
    }
    hello();
    var ready = Promise.resolve();
    if (!msgs.childElementCount) {
      if (state.id) {
        renderWelcome();
        ready = restore().then(schedulePoll);
      } else {
        state.restored = true;
        renderWelcome();
      }
    } else {
      schedulePoll();
    }
    scrollDown();
    if (!touch.matches) setTimeout(function () { ta.focus(); }, 50);
    return ready;
  }

  function closePanel() {
    state.open = false;
    panel.hidden = true;
    launch.setAttribute("aria-expanded", "false");
    if (mobile.matches) document.documentElement.style.overflow = prevOverflow;
    schedulePoll();
    launch.focus();
  }

  // Puhelimella painikkeen voi raahata toiseen kohtaan, jos se peittää jotain.
  // Paikka (vasen/oikea reuna ja korkeus) muistetaan selaimessa; tietokoneella painike on aina oikeassa alakulmassa.
  var POS_KEY = "hattibotti:pos";
  var EDGE = 12;
  var drag = null;
  var suppressClick = false;
  function loadPos() {
    try {
      var p = JSON.parse(localStorage.getItem(POS_KEY) || "null");
      return p && (p.side === "left" || p.side === "right") && isFinite(p.bottom) ? p : null;
    } catch (e) {
      return null;
    }
  }
  function clearPos() {
    launch.style.left = "";
    launch.style.right = "";
    launch.style.bottom = "";
  }
  function applyPos(p, animate) {
    if (!p || !mobile.matches) return clearPos();
    var w = launch.offsetWidth || 44;
    var h = launch.offsetHeight || 57;
    var bottom = Math.max(EDGE, Math.min(p.bottom, window.innerHeight - h - EDGE));
    if (animate) {
      launch.classList.add("snap");
      setTimeout(function () {
        launch.classList.remove("snap");
      }, 260);
    }
    launch.style.right = "auto";
    launch.style.left = (p.side === "left" ? EDGE : window.innerWidth - w - EDGE) + "px";
    launch.style.bottom = bottom + "px";
  }
  launch.addEventListener("pointerdown", function (e) {
    if (e.pointerType === "mouse" || !mobile.matches || state.open) return;
    var r = launch.getBoundingClientRect();
    drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, dx: e.clientX - r.left, dy: r.bottom - e.clientY, moved: false };
  });
  launch.addEventListener("pointermove", function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    if (!drag.moved) {
      if (Math.abs(e.clientX - drag.x0) + Math.abs(e.clientY - drag.y0) < 10) return;
      drag.moved = true;
      try {
        launch.setPointerCapture(e.pointerId);
      } catch (err) {}
      launch.classList.add("drag");
    }
    e.preventDefault();
    var w = launch.offsetWidth;
    var h = launch.offsetHeight;
    var x = Math.max(0, Math.min(window.innerWidth - w, e.clientX - drag.dx));
    var bottom = Math.max(0, Math.min(window.innerHeight - h, window.innerHeight - e.clientY - drag.dy));
    launch.style.right = "auto";
    launch.style.left = x + "px";
    launch.style.bottom = bottom + "px";
  });
  function endDrag(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    var d = drag;
    drag = null;
    if (!d.moved) return;
    launch.classList.remove("drag");
    // Raahauksen jälkeen ei avata chattia; painike siirtyy lähimpään reunaan
    suppressClick = true;
    setTimeout(function () {
      suppressClick = false;
    }, 450);
    var r = launch.getBoundingClientRect();
    var p = { side: r.left + r.width / 2 < window.innerWidth / 2 ? "left" : "right", bottom: Math.round(window.innerHeight - r.bottom) };
    try {
      localStorage.setItem(POS_KEY, JSON.stringify(p));
    } catch (err) {}
    applyPos(p, true);
  }
  launch.addEventListener("pointerup", endDrag);
  launch.addEventListener("pointercancel", endDrag);
  window.addEventListener("resize", function () {
    applyPos(loadPos());
  });
  if (mobile.addEventListener) {
    mobile.addEventListener("change", function () {
      applyPos(loadPos());
    });
  }

  launch.addEventListener("click", function (e) {
    if (suppressClick) {
      suppressClick = false;
      e.preventDefault();
      return;
    }
    if (state.open) closePanel();
    else openPanel();
  });
  teaser.addEventListener("click", openPanel);
  $(".cls").addEventListener("click", closePanel);
  clrBtn.addEventListener("click", showConfirm);
  confirmEl.querySelector(".cancel").addEventListener("click", hideConfirm);
  confirmEl.querySelector(".danger").addEventListener("click", clearConversation);
  helpBtn.addEventListener("click", function () {
    send("Haluan puhua myyjän kanssa.");
  });
  $(".call").addEventListener("click", showContacts);
  root.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" || !state.open) return;
    if (!confirmEl.hidden) hideConfirm();
    else if (panel.classList.contains("cv")) hideContacts();
    else closePanel();
  });
  attBtn.addEventListener("click", pickFiles);
  fileIn.addEventListener("change", function () {
    var files = Array.prototype.slice.call(fileIn.files || []);
    fileIn.value = "";
    attachFiles(files);
  });
  // Kuvan tai PDF:n voi raahata chat-ikkunaan
  var dragDepth = 0;
  var hasFiles = function (e) {
    var t = e.dataTransfer && e.dataTransfer.types;
    return !!t && Array.prototype.indexOf.call(t, "Files") >= 0;
  };
  panel.addEventListener("dragenter", function (e) {
    if (!hasFiles(e)) return;
    e.preventDefault();
    dragDepth++;
    panel.classList.add("dz");
  });
  panel.addEventListener("dragover", function (e) {
    if (!hasFiles(e)) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = "copy";
  });
  panel.addEventListener("dragleave", function (e) {
    if (!hasFiles(e)) return;
    dragDepth = Math.max(0, dragDepth - 1);
    if (!dragDepth) panel.classList.remove("dz");
  });
  panel.addEventListener("drop", function (e) {
    if (!hasFiles(e)) return;
    e.preventDefault();
    dragDepth = 0;
    panel.classList.remove("dz");
    var files = Array.prototype.filter.call(e.dataTransfer.files || [], function (f) {
      return /^image\//.test(f.type) || isPdf(f);
    });
    if (!files.length) return addError("Voit lähettää kuvia (JPG, PNG) tai PDF-tiedostoja.");
    attachFiles(files);
  });
  sendBtn.addEventListener("click", function () {
    send();
  });
  ta.addEventListener("input", function () {
    autosize();
    updateSend();
  });
  ta.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey && !e.isComposing) {
      e.preventDefault();
      send();
    }
  });
  ta.addEventListener("paste", function (e) {
    var items = (e.clipboardData && e.clipboardData.items) || [];
    var files = [];
    for (var i = 0; i < items.length; i++) {
      if (items[i].kind === "file" && (/^image\//.test(items[i].type) || items[i].type === "application/pdf")) files.push(items[i].getAsFile());
    }
    if (files.length) {
      e.preventDefault();
      attachFiles(files);
    }
  });
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden && state.id) doPoll();
  });

  // ------------------------------------------------------------------
  // Käynnistys
  // ------------------------------------------------------------------
  function start() {
    load();
    mount();
    applyPos(loadPos());
    // Hidastus jatkuu sivun vaihdon yli
    try {
      setSlow(Number(localStorage.getItem(SLOW_KEY)) || 0);
    } catch (e) {}
    if (state.id && state.status !== "bot") {
      setStatus(state.status);
      doPoll();
    }
    // "Rakenna pihavarasto" tai suunnitelmakortti vei PRKL-laskuriin → chat auki ja opastus
    // "Levysahaus" vei levysahauslaskuriin → chat auki ja valmis ohje
    var intent = takeIntent();
    var levyIntent = intent && intent.t === "levy" && onLevysahaus();
    if (intent && (levyIntent || (intent.t !== "levy" && onPrkl()))) {
      try {
        sessionStorage.setItem("hattibotti:teased", "1");
      } catch (e) {}
      setTimeout(function () {
        openPanel().then(function () {
          if (levyIntent) showLevyWelcome();
          else showPrklWelcome(intent.t);
        });
      }, 700);
    }
    // Pieni vihje työpöydällä kerran istunnossa
    try {
      if (!sessionStorage.getItem("hattibotti:teased") && !mobile.matches && !state.id) {
        setTimeout(function () {
          if (state.open) return;
          teaser.hidden = false;
          sessionStorage.setItem("hattibotti:teased", "1");
          setTimeout(function () {
            teaser.hidden = true;
          }, 9000);
        }, 6000);
      }
    } catch (e) {}
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
